import { Car, CarsharingAwareTrafficNode, Connection, ContextAwareTrafficNode, Disruption, HTTP_METHOD, Line, LINE_SELECTION, Location, MAP_PROJECTION, MAX_CHANGE, MOBILITY_IMPAIRMENT, Mot, MOT_TYPE, MULTI_MODALITY_TYPE, PartialConnection, PLATFORM_TYPE, RESPONSE_TYPE, STOP_SEQUENCE, TariffInformation, TimetableEvent, TimetableTrafficNode, TrafficNode, TRAFFICNODE_TYPE, Transition, TRANSITION_SEQUENCE, TRANSITION_TYPE, TransitionSection, TRANSPORTATION_CATEGORY, WALKING_SPEED, ERROR_CODE, LANGUAGE, TICKET_TYPE, Provider, Platform, Ticket, PriceLevel } from '@projektionisten/mobi-template-model';
import * as dayjs from 'dayjs';
import { of, throwError } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { isNullOrUndefined, isUndefined } from 'util';
import { EFA_STA_MOT_TYPE } from '../helper/efaStaApiEnums';
import { Helper } from '../helper/helper';
import { DISRUPTION_PRIORITY, DISRUPTION_TYPE, ROUTE_TYPE } from '@projektionisten/mobi-template-model/dist/src/enums/model.enums';
export class EFASTAInformationInterface {
    constructor(appSettings, apiToAppMatcher, http, prefix = '', isApp) {
        this.prefix = prefix;
        this.helper = new Helper();
        // *
        // *
        // *
        // TODO:        Attention -> just oev is specified for this kind of api-query-layer to only search for oev connections
        // *
        // *
        // *
        // TODO: refactoring, move to appSettings
        // TODO: Alle möglichen Modale sind hier aufgelistet und werden darüber auch einsprechend in den Anfragen ausgelöst. Das sind
        // TODO: dadurch z.Zt. immmer 4 parallele Server Anfragen. Das soll noch in die Oberfläche geführt werden, so dass sich der Nutzer die
        // TODO: gewünschten Modale auswählen kann. ÖV soll immer kommen
        this.mmTypes = ['oev'];
        // https://parameter-doku.mentz.net/dokumentation/http-parameter-dokumentation/eingabe/anhang/objekttypen
        // as default we use the filter for only stops
        this.defaultObjFilter = '2';
        // if we need more than stops we use 8 (for address), 1 (for cities) and 2 (for stops), those numbers are added to the sum of 11
        this.allObjFilter = '11';
        // TODO: refactoring, move to appSettings
        this.appModel = {
            settings: {
                // TODO: Einstellungsparameter für die Verbindungsauskunft an das vorhandene AppModel anschliessen
                detailParameter: {
                    detailParameter_maxChanges: 9,
                    detailParameter_changeSpeed: 'normal',
                    detailParameter_lineRestriction: 400,
                    detailParameter_noSolidStairs: false,
                    detailParameter_noEscalators: false,
                    detailParameter_noElevators: false,
                    detailParameter_lowPlatformVhcl: false,
                    detailParameter_wheelchair: false,
                    detailParameter_inclMOT_0: true,
                    detailParameter_inclMOT_1: true,
                    detailParameter_inclMOT_2: true,
                    detailParameter_inclMOT_3: true,
                    detailParameter_inclMOT_4: true,
                    detailParameter_inclMOT_5: true,
                    detailParameter_inclMOT_6: true,
                    detailParameter_inclMOT_7: true,
                    detailParameter_inclMOT_8: true,
                    detailParameter_inclMOT_9: true,
                    detailParameter_inclMOT_10: true,
                    detailParameter_inclMOT_11: true
                }
            },
            useRealtime: 1,
            // coordOutputFormat als Übergabe-Parameter steuert das Koordinaten-Format im Response -> hier WGS84 = Gaus-Krüger
            coordOutputFormat: 'WGS84[DD.ddddd]',
            // Speicherungs-Array für die serverseitige sessionID und requestID zur Steuerung von Früher + Später Anfragen
            // Wird für die Multi-Modalen Anfragen benötigt, da jede Anfrage separat gestellt wird und eine eigene sessionID und requestID hat
            sessionIDs: [],
            requestIDs: []
        };
        // TODO: refactoring, move to appSettings
        // Konstanten im EFA Server Umfeld
        this.Constants = {
            // Wenn ein stop eindeutig identifizierbar ist (z.B. durch eine stopId oder durch eine vollständig und richtig geschriebene
            // Adresse oder Haltestelle
            IDENTIFIED: 'identified',
            // Wenn ein stop nicht eindeutig identifizierbar ist
            // der EFA Server kann in diesem Fällen dann eine Liste zur Auswahl zurückliefern, muss evtl. noch entsprechend berücksichtigt
            // werden
            NOT_IDENTIFIED: 'notidentified',
            // stop -> Haltestelle
            STOP: 'stop',
            // coord -> Koordinate Format [X]:[Y]:[FORMAT] Bsp.: 9.73191:52.37470:WGS84[DD.ddddd]
            COORD: 'coord',
            // address -> Adresse (Strasse, Hausnummer)
            ADDRESS: 'address',
            // In Response: street -> Adresse (Strasse, Hausnummer)
            STREET: 'street',
            // In Response: singlehouse
            SINGLEHOUSE: 'singlehouse',
            // poi -> Point of Interest
            POI: 'poi',
            // 3 carsharing typen
            STADTMOBIL: 'STADTMOBIL',
            STADTFLITZER: 'Stadtflitzer',
            GREENWHEELS: 'Quicar',
            // any -> gemischte bzw. nicht festgelegte Übergabe (-> dadurch wird in allen möglichen Mengen (stop, address, poi, etc.) gesucht
            ANY: 'any',
            // Ortschaft
            PLACE: 'place'
        };
        this.HTTPCONSTANTS = {
            OK: 200,
            NOT_MODIFIED: 304
        };
        /**
         * Sorting function for connections
         */
        this.oSortFunction = (o1, o2) => {
            if (o1.startDateTime > o2.startDateTime) {
                return 1;
            }
            if (o1.startDateTime < o2.startDateTime) {
                return -1;
            }
            return 0;
        };
        this.appSettings = appSettings;
        this.apiToAppMatcher = apiToAppMatcher;
        this.http = http;
        this.pathVariation = isApp ? 'app' : 'web';
    }
    /**
     * traffic node finder for string input
     * @param params
     * @returns {Observable<TrafficNode[]>}
     */
    getTrafficNodesForStringInput(params) {
        const endpointUrl = 'https://efa.sta.bz.it/' + this.pathVariation + '/XML_STOPFINDER_REQUEST';
        // XML_STOPFINDER_REQUEST
        /////////////////////
        // coordOutputFormat: sCoordOutputFormat, /* TODO */
        // locationServerActive: 1,
        // useHouseNumberList: true,
        // anyObjFilter_sf: sAnyObjFilter,
        // reducedAnyTooManyObjFilter_sf: sReducedAnyTooManyObjFilter,
        // anyMaxSizeHitList: sAnyMaxSizeHitList,
        //
        // type_sf: sType,
        // name_sf: stopFinderString,
        //
        // outputFormat: 'JSON',
        // outputEncoding: 'UTF-8',
        //
        // uuid: 'GVH_APP',
        //
        // anyResSort_sf: 'NDS',
        //
        // mId: mandatorId
        /////////////////////
        // Parameter für den STOPFINDER_REQUEST werden gesetzt
        // Doku: http://80.154.30.143:8080/mdv/dokumentation/http-parameter-dokumentation/eingabe/http-requests/stop-finder-request
        const processedParams = {
            language: params.language === LANGUAGE.EN ? LANGUAGE.DE : params.language,
            coordOutputFormat: this.appModel.coordOutputFormat
        };
        if (!isUndefined(params.input)) {
            // request type is set to any to get stops, address and poi
            const requestType = this.Constants.ANY;
            // params used for the stopfinder request get set
            processedParams.locationServerActive = 1;
            processedParams.useHouseNumberList = true;
            processedParams.type_sf = requestType;
            processedParams.name_sf = params.input.trim();
            // if search params are coordinates search for coordinates
        }
        else if (!isUndefined(params.location) && params.location instanceof Location) {
            processedParams.type_sf = this.Constants.COORD;
            processedParams.name_sf = `${params.location.longitude}:${params.location.latitude}:WGS84[DD.ddddd]`;
        }
        if (!isUndefined(params.objectFilter)) {
            // convert trafficnode types to efa object types and use their sum for the objectfilter
            params.objectFilter = params.objectFilter.map((type) => this.getEfaType(type));
            processedParams.anyObjFilter_sf = params.objectFilter.reduce((a, b) => a + b, 0);
        }
        processedParams.odvSugMacro = true;
        // TODO: refactoring
        return this.performRequest(endpointUrl, processedParams).pipe(mergeMap((response) => {
            const listOfStops = [];
            // checks the HTTP Status Code
            if (response.status.code !== this.HTTPCONSTANTS.OK && response.status.code !== this.HTTPCONSTANTS.NOT_MODIFIED) {
                return throwError([{ code: 'ERROR_CODE.GENERAL_SERVER_ERROR', value: response.status.code }]);
            }
            const data = response.body;
            // checks for MENTZ Errors in Response.
            // if any code discovered complete with an error
            const errorArray = this.checkResultForServerError(data.stopFinder);
            if (errorArray.length > 0 && isNullOrUndefined(data.stopFinder.points)) {
                return throwError(errorArray);
            }
            // Wenn keine Ergebnisse zurückgeliefert werden, dann die Methode verlassen
            // TODO: Wahrscheinlich muss hier noch Server-Error Handling integriert werden, denn der Server liefert bei
            // TODO: leeren Listen und anderen Fehlern entsprechende Hinweise
            if (isNullOrUndefined(data.stopFinder.points)) {
                return of([]);
            }
            // Wenn der STOPFINDER_REQUEST nur einen Result-Item enthält, dann muss dieser in ein Array umgewandelt werden
            if (!data.stopFinder.points.length) {
                data.stopFinder.points = [data.stopFinder.points.point];
            }
            // Nach "Quality" sortieren.
            data.stopFinder.points.sort((a, b) => Number(b.quality) - Number(a.quality));
            // Alle Items der Ergebnisliste in TrafficNodes umwandeln
            for (const oJSON of data.stopFinder.points) {
                // Ort des Ergebnis-Items
                const sPlace = (oJSON.ref && oJSON.ref.place) ? oJSON.ref.place : oJSON.mainLoc;
                // In manchen Fällen kommt ein Name des Gebäudes mit
                const sBuildingName = oJSON.buildingName;
                // In manchen Fällen kommt auch einen Nummer des Gebäudes mit
                const sBuildingNumber = oJSON.buildingNumber;
                // Der komplette Name des Items setzt sich aus 'object' und den Informationen zu BuildingName und
                // BuildingNumber zusammen
                let sName = '';
                if (!isUndefined(oJSON.object)) {
                    sName = oJSON.object + ((sBuildingNumber && sBuildingNumber !== '') ? ' ' + sBuildingNumber : '');
                }
                else {
                    // wenn punkte für eine Location aufgelöst werden, sind sowohl object als auch mainLoc nicht gesetzt
                    const splitName = oJSON.name.split(', ');
                    if (splitName.length > 1) {
                        sName = splitName[1];
                    }
                    else {
                        sName = splitName[0];
                    }
                }
                // Koordinate des Ergebnis-Items aus dem String coords ableiten. Sie ist dort Komma-separiert gespeichert
                // (wenn vorhanden)
                let xCoord;
                let yCoord;
                let sStateless;
                if (oJSON.ref.coords !== undefined) {
                    xCoord = oJSON.ref.coords.split(',')[0];
                    yCoord = oJSON.ref.coords.split(',')[1];
                }
                else {
                    // actually just don't include that point, because we can't do anything useful with it
                    continue;
                }
                try {
                    // dies ist eine ein-eindeutige ID des Items (falls vorhanden)
                    sStateless = oJSON.stateless;
                }
                catch (err) {
                    console.log(err);
                }
                const type = this.getTypeOfTrafficNodeForPoint(oJSON);
                // Neuen TrafficNode mit den oben zusammengestellten Informationen erzeugen
                const newNode = TrafficNode.factory({
                    id: sStateless,
                    name: sName,
                    city: sPlace ||
                        ((this.appSettings.VENDOR_CONSTANTS !== undefined
                            && this.appSettings.VENDOR_CONSTANTS.APP !== undefined)
                            ? this.appSettings.VENDOR_CONSTANTS.APP.DEFAULT_CITY : ''),
                    type: type,
                    location: Location.factory({
                        latitude: yCoord,
                        longitude: xCoord,
                        projection: MAP_PROJECTION.GK4
                    })
                });
                listOfStops.push(newNode);
            }
            return of(listOfStops);
        }), catchError((error) => {
            if (Array.isArray(error)) {
                return throwError(error);
            }
            else {
                return throwError([{ code: 'ERROR_CODE.GENERAL_SERVER_ERROR', value: !isNullOrUndefined(error.message) ? error.message : '' }]);
            }
        }));
    }
    /**
     * gets connection array from efa-nds api
     * @see {assembleConnectionsFromResults} for extracted
     * @param params.origin.id -> id from trafficNode from 'XML_STOPFINDER_REQUEST'
     * @param params.via.id -> id from trafficNode from 'XML_STOPFINDER_REQUEST'
     * @param params.destination.id -> id from trafficNode from 'XML_STOPFINDER_REQUEST'
     * @param params.time -> date time
     * @returns {Observable<Connection[]>}
     */
    getConnections(params) {
        const endpointUrl = 'https://efa.sta.bz.it/' + this.pathVariation + '/XML_TRIP_REQUEST2';
        // Die Eingaben aus der Oberfläche in den Objekten 'originStopItem' und 'destinationStopItem'
        // Da die Informationen aus dem STOPFINDER_REQUEST genutzt werden sind die Stops schon IDENTIFIED
        // TODO: Im Moment wird noch fest der Type STOP (Haltestelle) gesetzt. Dies muss noch für den Type Address, Coord und POI
        // TODO: ergänzt werden -> Implementierung in getParameterStringPart für Address, Coord und POI noch fehlerhaft
        const oArgs = {
            originStopItem: {
                nameState: (params.origin.type === TRAFFICNODE_TYPE.COORDS
                    || params.origin.type === TRAFFICNODE_TYPE.W3W
                    || params.origin.type === TRAFFICNODE_TYPE.PLUSCODES)
                    ? this.Constants.COORD : this.Constants.IDENTIFIED,
                node: params.origin
            },
            viaStopItem: {
                nameState: params.via !== undefined
                    ? ((params.via.type === TRAFFICNODE_TYPE.COORDS
                        || params.via.type === TRAFFICNODE_TYPE.W3W
                        || params.via.type === TRAFFICNODE_TYPE.PLUSCODES)
                        ? this.Constants.COORD : this.Constants.IDENTIFIED) : undefined,
                node: params.via
            },
            destinationStopItem: {
                nameState: (params.destination.type === TRAFFICNODE_TYPE.COORDS
                    || params.destination.type === TRAFFICNODE_TYPE.W3W
                    || params.destination.type === TRAFFICNODE_TYPE.PLUSCODES)
                    ? this.Constants.COORD : this.Constants.IDENTIFIED,
                node: params.destination
            },
            time: params.time,
            isArrivalTime: params.isArrivalTime || false,
            mobilityPreferences: params.mobilityPreferences
        };
        // Die nötigen Übergabe-Parameter für die TRIP_REQUEST2 Anfrage an den EFA Server zusammenstellen
        const processedParams = this.getParameterStringForTripRequest(oArgs);
        processedParams.language = params.language === LANGUAGE.EN
            ? LANGUAGE.DE
            : (params.language === LANGUAGE.LAD ? LANGUAGE.IT : params.language);
        processedParams.odvMacro = true;
        return this.performRequest(endpointUrl, processedParams).pipe(mergeMap((response) => {
            // checks the HTTP Status Code
            if (response.status.code !== this.HTTPCONSTANTS.OK && response.status.code !== this.HTTPCONSTANTS.NOT_MODIFIED) {
                return throwError([{ code: 'ERROR_CODE.GENERAL_SERVER_ERROR', value: response.status.code }]);
            }
            const data = response.body;
            // checks for MENTZ Errors in Response.
            // if any code discovered complete with an error
            const errorArray = this.checkResultForServerError(data);
            if (errorArray.length > 0) {
                return throwError(errorArray);
            }
            // das Ergebnis-Array mit den Connections wird aus der EFA Server-Antwort zusammengestellt
            const connections = this.assembleConnectionsFromResults(data, 'oev');
            connections.sort(this.oSortFunction);
            return of(connections);
        }), catchError((error) => {
            if (Array.isArray(error)) {
                return throwError(error);
            }
            else {
                return throwError([{ code: 'ERROR_CODE.GENERAL_SERVER_ERROR', value: !isNullOrUndefined(error.message) ? error.message : '' }]);
            }
        }));
    }
    getEarlierConnections(params) {
        const endpointUrl = 'https://efa.sta.bz.it/' + this.pathVariation + '/XML_TRIP_REQUEST2';
        const processedParams = {
            // Zusätzlich wird hier das EFA Server Kommando 'tripPrev' gesetzt
            // Hierfür sind die sessionID und requestID des vorherigen Aufrufs nötig
            command: 'tripPrev',
            // sessionId: this.appModel.sessionIDs[mmType],
            // requestId: this.appModel.requestIDs[mmType]
            sessionID: params.sessionId,
            requestID: params.requestId
        };
        processedParams.language = params.language === LANGUAGE.EN
            ? LANGUAGE.DE
            : (params.language === LANGUAGE.LAD ? LANGUAGE.IT : params.language);
        return this.performRequest(endpointUrl, processedParams).pipe(mergeMap((response) => {
            // checks the HTTP Status Code
            if (response.status.code !== this.HTTPCONSTANTS.OK && response.status.code !== this.HTTPCONSTANTS.NOT_MODIFIED) {
                return throwError([{ code: 'ERROR_CODE.GENERAL_SERVER_ERROR', value: response.status.code }]);
            }
            const data = response.body;
            // checks for MENTZ Errors in Response.
            // if any code discovered complete with an error
            const errorArray = this.checkResultForServerError(data);
            if (errorArray.length > 0) {
                return throwError(errorArray);
            }
            // das Ergebnis-Array mit den Connections wird aus der EFA Server-Antwort zusammengestellt
            const connections = this.assembleConnectionsFromResults(data, 'oev');
            connections.sort(this.oSortFunction);
            return of(connections);
        }), catchError((error) => {
            if (Array.isArray(error)) {
                return throwError(error);
            }
            else {
                return throwError([{ code: 'ERROR_CODE.GENERAL_SERVER_ERROR', value: !isNullOrUndefined(error.message) ? error.message : '' }]);
            }
        }));
    }
    getLaterConnections(params) {
        const endpointUrl = 'https://efa.sta.bz.it/' + this.pathVariation + '/XML_TRIP_REQUEST2';
        const processedParams = {
            // Zusätzlich wird hier das EFA Server Kommando 'tripPrev' gesetzt
            // Hierfür sind die sessionID und requestID des vorherigen Aufrufs nötig
            command: 'tripNext',
            // sessionId: this.appModel.sessionIDs[mmType],
            // requestId: this.appModel.requestIDs[mmType]
            sessionID: params.sessionId,
            requestID: params.requestId
        };
        processedParams.language = params.language === LANGUAGE.EN
            ? LANGUAGE.DE
            : (params.language === LANGUAGE.LAD ? LANGUAGE.IT : params.language);
        return this.performRequest(endpointUrl, processedParams).pipe(mergeMap((response) => {
            // checks the HTTP Status Code
            if (response.status.code !== this.HTTPCONSTANTS.OK && response.status.code !== this.HTTPCONSTANTS.NOT_MODIFIED) {
                return throwError([{ code: 'ERROR_CODE.GENERAL_SERVER_ERROR', value: response.status.code }]);
            }
            const data = response.body;
            // checks for MENTZ Errors in Response.
            // if any code discovered complete with an error
            const errorArray = this.checkResultForServerError(data);
            if (errorArray.length > 0) {
                return throwError(errorArray);
            }
            // das Ergebnis-Array mit den Connections wird aus der EFA Server-Antwort zusammengestellt
            const connections = this.assembleConnectionsFromResults(data, 'oev');
            connections.sort(this.oSortFunction);
            return of(connections);
        }), catchError((error) => {
            if (Array.isArray(error)) {
                return throwError(error);
            }
            else {
                return throwError([{ code: 'ERROR_CODE.GENERAL_SERVER_ERROR', value: !isNullOrUndefined(error.message) ? error.message : '' }]);
            }
        }));
    }
    getTimetableEvents(params) {
        const endpointUrl = 'https://efa.sta.bz.it/' + this.pathVariation + '/XML_DM_REQUEST';
        const QUERY_DEFAULT_LIMIT = 30;
        let oArgs;
        let processedParams;
        if (params.command === 'dmPrev' || params.command === 'dmNext') {
            processedParams = {
                command: params.command,
                sessionID: params.sessionId,
                requestID: params.requestId
            };
        }
        else {
            oArgs = {
                time: !isNullOrUndefined(params.time) ? new Date(params.time) : new Date(),
                limit: params.limit || QUERY_DEFAULT_LIMIT,
                shorttermchanges: true,
                mentzonly: params.efa || false,
                departureid: params.departureid || undefined,
                stopItem: {
                    nameState: (params.node.type === TRAFFICNODE_TYPE.COORDS
                        || params.node.type === TRAFFICNODE_TYPE.W3W
                        || params.node.type === TRAFFICNODE_TYPE.PLUSCODES)
                        ? this.Constants.COORD : this.Constants.IDENTIFIED,
                    node: params.node
                },
                command: params.command,
                sessionId: params.sessionId,
                requestId: params.requestId,
                mobilityPreferences: params.mobilityPreferences,
                line: params.line
            };
            oArgs.time.setSeconds(0, 0);
            processedParams = this.getParameterStringForDMRequest(oArgs);
        }
        processedParams.language = params.language === LANGUAGE.EN
            ? LANGUAGE.DE
            : (params.language === LANGUAGE.LAD ? LANGUAGE.IT : params.language);
        return this.performRequest(endpointUrl, processedParams).pipe(mergeMap((response) => {
            var _a;
            // checks the HTTP Status Code
            if (response.status.code !== this.HTTPCONSTANTS.OK && response.status.code !== this.HTTPCONSTANTS.NOT_MODIFIED) {
                return throwError([{ code: 'ERROR_CODE.GENERAL_SERVER_ERROR', value: response.status.code }]);
            }
            const data = response.body;
            // checks for MENTZ Errors in Response.
            // if any code discovered complete with an error
            const errorArray = this.checkResultForServerError(data);
            if (errorArray.length > 0) {
                return throwError(errorArray);
            }
            // need to stringify then parse due to | character inside the string
            const resultFromServer = JSON.parse(JSON.stringify(data));
            const timetableEvents = [];
            let sessionId;
            let requestId;
            if (!isUndefined(resultFromServer.parameters) && resultFromServer.parameters !== undefined) {
                for (const oParameter of resultFromServer.parameters) {
                    if (oParameter.name === 'sessionID') {
                        sessionId = oParameter.value;
                    }
                    if (oParameter.name === 'requestID') {
                        requestId = oParameter.value;
                    }
                }
            }
            if (!isNullOrUndefined(resultFromServer.departureList)) {
                if (!resultFromServer.departureList.length) {
                    resultFromServer.departureList = [resultFromServer.departureList.departure];
                }
                for (const departure of resultFromServer.departureList) {
                    const matchedMot = this.getEFA_MotMapping(Number(departure.servingLine.code), departure.servingLine.name);
                    let matchedPlatform;
                    matchedPlatform = this.getMatchedPlatform(departure.pointType);
                    const stopsOfTheLine = [];
                    // --- Filter for node name and city in current node (the node the user searched for) ---
                    let nameOfCurrentNode = '';
                    let cityOfCurrentNode = '';
                    if (departure.nameWO !== '' && !isUndefined(departure.place) && departure.place !== '') {
                        nameOfCurrentNode = departure.nameWO;
                        cityOfCurrentNode = departure.place;
                    }
                    else {
                        let splitString;
                        // determine whether we have to split the city and name by comma, slash or whitespace
                        if (departure.stopName.indexOf(',') !== -1) {
                            splitString = departure.stopName.split(', ');
                        }
                        else if (departure.stopName.indexOf('/') !== -1) {
                            splitString = departure.stopName.split('/');
                        }
                        else {
                            splitString = departure.stopName.split(' ');
                        }
                        cityOfCurrentNode = splitString[0];
                        nameOfCurrentNode = departure.nameWO !== '' ? departure.nameWO : splitString.slice(1, splitString.length);
                    }
                    // --- End of name filter ---
                    let excludeInTrip = false;
                    if (departure.realtimeStatus !== undefined && departure.realtimeStatus !== '') {
                        excludeInTrip = departure.realtimeStatus === 'DEPARTURE_CANCELLED' ||
                            departure.realtimeStatus === 'NO_CALL_AT_STOP' ||
                            departure.realtimeStatus === 'TRIP_CANCELLED' ||
                            departure.realtimeStatus === 'ARRIVAL_CANCELLED';
                    }
                    const currentStop = TimetableTrafficNode.factory({
                        name: nameOfCurrentNode,
                        city: cityOfCurrentNode,
                        id: departure.stopID,
                        excludeInTrip: excludeInTrip,
                        location: Location.factory({
                            latitude: departure.y,
                            longitude: departure.x
                        }),
                        type: TRAFFICNODE_TYPE.STOP,
                        departureDateTime: this.helper.getTimeForDmTimeFormat(departure.dateTime),
                        actualDepartureDateTime: !isUndefined(departure.realDateTime)
                            ? this.helper.getTimeForDmTimeFormat(departure.realDateTime)
                            : this.helper.getTimeForDmTimeFormat(departure.dateTime),
                        positionInSequence: STOP_SEQUENCE.CURRENT
                    });
                    if (!isNullOrUndefined(departure.prevStopSeq)) {
                        if (departure.prevStopSeq.length > 1) {
                            for (const stop of departure.prevStopSeq) {
                                const previousStop = this.getTimetableTrafficNodeFromStop(stop, this.apiToAppMatcher.matchMotToApp(matchedMot.type, matchedMot.category));
                                previousStop.positionInSequence = STOP_SEQUENCE.PREVIOUS;
                                stopsOfTheLine.push(previousStop);
                            }
                        }
                        else {
                            const previousStop = this.getTimetableTrafficNodeFromStop(departure.prevStopSeq, this.apiToAppMatcher.matchMotToApp(matchedMot.type, matchedMot.category));
                            previousStop.positionInSequence = STOP_SEQUENCE.PREVIOUS;
                            if (previousStop.id !== currentStop.id) {
                                stopsOfTheLine.push(previousStop);
                            }
                        }
                    }
                    // add current stop after previous stops
                    stopsOfTheLine.push(currentStop);
                    if (!isNullOrUndefined(departure.onwardStopSeq)) {
                        if (departure.onwardStopSeq.length > 1) {
                            for (const stop of departure.onwardStopSeq) {
                                const onwardStop = this.getTimetableTrafficNodeFromStop(stop, this.apiToAppMatcher.matchMotToApp(matchedMot.type, matchedMot.category));
                                onwardStop.positionInSequence = STOP_SEQUENCE.ONWARD;
                                stopsOfTheLine.push(onwardStop);
                            }
                        }
                        else {
                            const onwardStop = this.getTimetableTrafficNodeFromStop(departure.onwardStopSeq, this.apiToAppMatcher.matchMotToApp(matchedMot.type, matchedMot.category));
                            onwardStop.positionInSequence = STOP_SEQUENCE.ONWARD;
                            stopsOfTheLine.push(onwardStop);
                        }
                    }
                    const disruptions = [];
                    if (!isNullOrUndefined(departure.stopInfos)) {
                        if (departure.stopInfos.length > 1) {
                            for (const info of departure.stopInfos) {
                                disruptions.push(Disruption.factory({
                                    id: info.infoID,
                                    headers: [
                                        info.infoText.subtitle,
                                        info.infoText.subject
                                    ],
                                    content: [
                                        info.infoText.content,
                                        info.infoText.additionalText
                                    ],
                                    url: info.infoLinkURL
                                }));
                            }
                        }
                        else {
                            disruptions.push(Disruption.factory({
                                id: departure.stopInfos.stopInfo.infoID,
                                headers: [
                                    departure.stopInfos.stopInfo.infoText.subtitle,
                                    departure.stopInfos.stopInfo.infoText.subject
                                ],
                                content: [
                                    departure.stopInfos.stopInfo.infoText.content,
                                    departure.stopInfos.stopInfo.infoText.additionalText
                                ],
                                url: departure.stopInfos.stopInfo.infoLinkURL
                            }));
                        }
                    }
                    if (!isNullOrUndefined(departure.lineInfos)) {
                        if (departure.lineInfos.length > 1) {
                            for (const info of departure.lineInfos) {
                                disruptions.push(Disruption.factory({
                                    headers: [
                                        info.infoText.subtitle,
                                        info.infoText.subject
                                    ],
                                    content: [
                                        info.infoText.content,
                                        info.infoText.additionalText
                                    ],
                                    url: info.infoLinkURL
                                }));
                            }
                        }
                        else {
                            disruptions.push(Disruption.factory({
                                headers: [
                                    departure.lineInfos.lineInfo.infoText.subtitle,
                                    departure.lineInfos.lineInfo.infoText.subject
                                ],
                                content: [
                                    departure.lineInfos.lineInfo.infoText.content,
                                    departure.lineInfos.lineInfo.infoText.additionalText
                                ],
                                url: departure.lineInfos.lineInfo.infoLinkURL
                            }));
                        }
                    }
                    timetableEvents.push(TimetableEvent.factory({
                        id: departure.stopID,
                        mot: Mot.factory({
                            type: this.apiToAppMatcher.matchMotToApp(matchedMot.type, matchedMot.category),
                            category: matchedMot.category
                        }),
                        line: Line.factory({
                            direction: TrafficNode.factory({
                                id: departure.servingLine.destID,
                                name: departure.servingLine.direction
                            }),
                            name: !isUndefined(departure.servingLine.trainType)
                                ? departure.servingLine.trainType + ' ' + departure.servingLine.trainNum
                                : departure.servingLine.number,
                            operator: (_a = departure.operator) === null || _a === void 0 ? void 0 : _a.name
                        }),
                        platform: Platform.factory({
                            // Platform name 1 and type PLATFORM as defaults, like in DVB
                            // because when there is no platform, there is usually only one platform
                            name: !isUndefined(departure.platformName) ? departure.platformName : '',
                            type: !isUndefined(matchedPlatform) ? matchedPlatform : PLATFORM_TYPE.PLATFORM
                        }),
                        nodes: stopsOfTheLine,
                        scheduledDepartureDateTime: this.helper.getTimeForDmTimeFormat(departure.dateTime),
                        actualDepartureDateTime: !isUndefined(departure.realDateTime)
                            ? this.helper.getTimeForDmTimeFormat(departure.realDateTime)
                            : this.helper.getTimeForDmTimeFormat(departure.dateTime),
                        disruptions: disruptions,
                        additionalInfo: !isNullOrUndefined(departure.servingLine.itdNoTrain) ? [].concat(departure.servingLine.itdNoTrain) : [],
                        sessionId: sessionId,
                        requestId: requestId,
                        realTimeControlled: !isNullOrUndefined(departure.realDateTime)
                    }));
                }
            }
            return of(timetableEvents);
        }), catchError((error) => {
            if (Array.isArray(error)) {
                return throwError(error);
            }
            else {
                return throwError([{ code: 'ERROR_CODE.GENERAL_SERVER_ERROR', value: !isNullOrUndefined(error.message) ? error.message : '' }]);
            }
        }));
    }
    getEarlierTimetableEvents(params) {
        params.command = 'dmPrev';
        return this.getTimetableEvents(params);
    }
    getLaterTimetableEvents(params) {
        params.command = 'dmNext';
        return this.getTimetableEvents(params);
    }
    /**
     * gets all stops that are near by the coordinates
     * Used for listing the actual stops close to a searched location or the departure monitor
     * @param {Location} location
     * @returns {Observable<ContextAwareTrafficNode[]>} List of trafficNodes that are around the coordinates
     */
    getStopsForCoords(params) {
        const endpointUrl = 'https://efa.sta.bz.it/' + this.pathVariation + '/XML_DM_REQUEST';
        const processedParams = {
            language: params.language,
            useRealtime: this.appModel.useRealtime,
            locationServerActive: 1,
            coordOutputFormat: this.appModel.coordOutputFormat,
            limit: 25,
            type_dm: this.Constants.COORD,
            name_dm: location ? params.location.longitude + ':' + params.location.latitude + ':' + this.appModel.coordOutputFormat : '',
            useAllStops: 1,
            uuid: this.appModel.uuid,
            mId: this.appModel.mId,
            mobilityPreferences: params.mobilityPreferences
        };
        Object.assign(processedParams, this.getMots(processedParams));
        return this.performRequest(endpointUrl, processedParams).pipe(mergeMap((response) => {
            var _a, _b, _c;
            // checks the HTTP Status Code
            if (response.status.code !== this.HTTPCONSTANTS.OK && response.status.code !== this.HTTPCONSTANTS.NOT_MODIFIED) {
                return throwError([{ code: 'ERROR_CODE.GENERAL_SERVER_ERROR', value: response.status.code }]);
            }
            const data = response.body;
            // checks for MENTZ Errors in Response.
            // if any code discovered complete with an error
            const errorArray = this.checkResultForServerError(data);
            if (errorArray.length > 0) {
                return throwError(errorArray);
            }
            const resultFromServer = JSON.parse(JSON.stringify(data));
            const trafficNodes = [];
            if (!isUndefined(resultFromServer.dm) && !isUndefined(resultFromServer.dm.itdOdvAssignedStops)) {
                let justOneStop = false;
                if (resultFromServer.dm.itdOdvAssignedStops.length === undefined) {
                    resultFromServer.dm.itdOdvAssignedStops = [resultFromServer.dm.itdOdvAssignedStops];
                    justOneStop = true;
                }
                for (const stop of resultFromServer.dm.itdOdvAssignedStops) {
                    const lines = [];
                    if (!isUndefined(resultFromServer.servingLines) && ((_a = resultFromServer.servingLines) === null || _a === void 0 ? void 0 : _a.lines)) {
                        if (resultFromServer.servingLines.lines.length === undefined) {
                            resultFromServer.servingLines.lines = [resultFromServer.servingLines.lines];
                        }
                        for (let line of resultFromServer.servingLines.lines) {
                            // unwrap extra attribute line when the result contains only one line (STA-738)
                            if (resultFromServer.servingLines.lines.length === 1 &&
                                ((_b = resultFromServer.servingLines.lines[0]) === null || _b === void 0 ? void 0 : _b.line) !== undefined) {
                                line = (_c = resultFromServer.servingLines.lines[0]) === null || _c === void 0 ? void 0 : _c.line;
                            }
                            const matchedMot = this.getEFA_MotMapping(Number(line === null || line === void 0 ? void 0 : line.mode.code), line === null || line === void 0 ? void 0 : line.mode.name);
                            if ((line === null || line === void 0 ? void 0 : line.assignedStopID) === stop.stopID || justOneStop) {
                                lines.push(Line.factory({
                                    mot: Mot.factory({
                                        type: this.apiToAppMatcher.matchMotToApp(matchedMot.type, matchedMot.category),
                                        category: TRANSPORTATION_CATEGORY.MOT
                                    })
                                }));
                            }
                        }
                    }
                    trafficNodes.push(ContextAwareTrafficNode.factory({
                        id: stop.stopID,
                        name: stop.name,
                        city: stop.place,
                        location: Location.factory({
                            longitude: stop.x,
                            latitude: stop.y
                        }),
                        type: TRAFFICNODE_TYPE.STOP,
                        distance: stop.distance,
                        servingLines: lines
                    }));
                }
            }
            return of(trafficNodes);
        }), catchError((error) => {
            if (Array.isArray(error)) {
                return throwError(error);
            }
            else {
                return throwError([{ code: 'ERROR_CODE.GENERAL_SERVER_ERROR', value: !isNullOrUndefined(error.message) ? error.message : '' }]);
            }
        }));
    }
    /**
     * request ticket list for shop
     * @param params
     * @returns {Observable<Ticket[]>}
     */
    getAvailableTickets(params) {
        throw new Error('NotImplementedException: use EFA NDS API instead!');
    }
    /**
     * Gets all Nodes of interest in a given radius to a point or within latlng Bounds.
     * Thoses nodes get matched to TrafficNode objects to be displayed as markers on a map
     * @param params Object of several parameters, see below
     *
     * Take notice of these internal paramaters:
     * @param params.carsharing: boolean - If set to false, paramaters for carsharing nodes are omitted
     * and no nodes of that type will come back from the request. Default value: true
     */
    getMapNodes(params) {
        const endpointUrl = 'https://efa.sta.bz.it/' + this.pathVariation + '/XML_COORD_REQUEST';
        // Parameter für den XML_COORD_REQUEST werden gesetzt
        // Doku: http://80.154.30.143:8080/mdv/dokumentation/http-parameter-dokumentation/eingabe/http-requests/coord-
        // info-request-koordinaten-anfrage
        const processedParams = {
            language: params.language === LANGUAGE.EN ? LANGUAGE.DE : params.language,
            coordOutputFormat: this.appModel.coordOutputFormat,
            inclFilter: 1,
            coordListFormat: 'JSON',
            coordListOutputFormat: 'JSON',
            scale: 14,
            type_1: 'stop',
            coord: '' + params.center.longitude + ':' + params.center.latitude + ':WGS84[DD.ddddd]',
            radius_1: params.radius
        };
        if (isUndefined(params.carsharing) || params.carsharing === true) {
            processedParams.vehSM = 'RADIAL';
            processedParams.vehSpec = 1;
            processedParams.vehAtStation = 1;
            processedParams.vehSR = 1;
            processedParams.vehSF = 'car';
        }
        return this.performRequest(endpointUrl, processedParams).pipe(mergeMap((response) => {
            const listOfStops = [];
            // checks the HTTP Status Code
            if (response.status.code !== this.HTTPCONSTANTS.OK && response.status.code !== this.HTTPCONSTANTS.NOT_MODIFIED) {
                return throwError([{ code: 'ERROR_CODE.GENERAL_SERVER_ERROR', value: response.status.code }]);
            }
            const data = response.body;
            // checks for MENTZ Errors in Response.
            // if any code discovered complete with an error
            const errorArray = this.checkResultForServerError(data);
            if (errorArray.length > 0) {
                return throwError(errorArray);
            }
            // Alle Items der Ergebnisliste in TrafficNodes umwandeln
            for (const oJSON of data.pins) {
                // Koordinate des Ergebnis-Items aus dem String coords ableiten. Sie ist dort Komma-separiert gespeichert
                // (wenn vorhanden)
                let xCoord;
                let yCoord;
                if (oJSON.coords !== undefined) {
                    xCoord = oJSON.coords.split(',')[0];
                    yCoord = oJSON.coords.split(',')[1];
                }
                else {
                    // actually just don't include that point, because we can't do anything useful with it
                    continue;
                }
                const type = this.getTypeOfTrafficNodeForPoint(oJSON);
                const distance = oJSON.distance !== '' ? oJSON.distance : 0;
                const servingLines = this.getServingMotsFromMapPin(oJSON).map((e) => {
                    return Line.factory({
                        mot: e
                    });
                });
                const availableCars = [];
                if (type === TRAFFICNODE_TYPE.CARSHARING_STADTMOBIL && !isUndefined(oJSON.attrs)) {
                    const vehicles = oJSON.coordInfoDetails.station.vehDetails;
                    for (const vehicle of vehicles) {
                        const newCar = {};
                        newCar.id = vehicle.id;
                        newCar.name = vehicle.plate;
                        availableCars.push(Car.factory(newCar));
                    }
                    for (let i = 0; i < oJSON.attrs.length; i++) {
                        if (oJSON.attrs[i].name === 'VehicleID') {
                            const newCar = {};
                            newCar.id = oJSON.attrs[i].value;
                            if (!isUndefined(oJSON.attrs[i + 1] && oJSON.attrs[i + 1].name === ('Name_' + newCar.id))) {
                                newCar.name = oJSON.attrs[i + 1].value;
                            }
                            availableCars.push(Car.factory(newCar));
                        }
                    }
                }
                // Neuen TrafficNode mit den oben zusammengestellten Informationen erzeugen
                const newNode = CarsharingAwareTrafficNode.factory({
                    id: !isUndefined(oJSON.stateless) ? oJSON.stateless : '',
                    name: oJSON.desc,
                    city: oJSON.locality,
                    type: type,
                    location: Location.factory({
                        latitude: yCoord,
                        longitude: xCoord,
                        projection: MAP_PROJECTION.WGS84
                    }),
                    distance: distance,
                    servingLines: servingLines,
                    availableCars: availableCars
                });
                listOfStops.push(newNode);
            }
            return of(listOfStops);
        }), catchError((error) => {
            if (Array.isArray(error)) {
                return throwError(error);
            }
            else {
                return throwError([{ code: 'ERROR_CODE.GENERAL_SERVER_ERROR', value: !isNullOrUndefined(error.message) ? error.message : '' }]);
            }
        }));
    }
    /**
     * Method to get a (filtered) list of traffic messages with disruptions and long term changes. Used in 'ics' module
     * @param params Object of possible parameters to be parsed
     */
    getTrafficMessages(params) {
        const endpointUrl = 'https://efa.sta.bz.it/' + this.pathVariation + '/XML_ADDINFO_REQUEST';
        const lines = [];
        if (!isUndefined(params.lines)) {
            for (const line of params.lines) {
                lines.push(line.lineNumberId);
            }
        }
        let zones = [];
        if (!isUndefined(params.zones)) {
            zones = [].concat(params.zones);
        }
        let city = '';
        if (!isUndefined(params.city) && params.city.length > 0) {
            city = city + params.city[0];
            if (params.city.length > 1) {
                for (let i = params.city[0] + 1; i <= params.city[params.city.length - 1]; i++) {
                    city = city + ':' + i;
                }
            }
        }
        params.date = !isUndefined(params.date) ? params.date : new Date();
        // Parameter für den XML_COORD_REQUEST werden gesetzt
        // Doku: http://80.154.30.143:8080/mdv/dokumentation/http-parameter-dokumentation/eingabe/http-requests
        // /coord-info-request-koordinaten-anfrage
        const reduction = [
            'removeGenericParams',
            'removeITIncident',
            'removeLastModificationTime',
            'removeSourceSystem'
        ];
        if (params.filterTimes) {
            reduction.push('removeCreationTime', 'removeExpirationTime');
        }
        if (params.filterStops) {
            reduction.push('removeStops');
        }
        const processedParams = {
            // heißt bei ics nur publicationStatus, müsste laut doku aber falsch sein
            filterPublicationStatus: 'current',
            filterOMC: city,
            filterProviderCode: zones,
            itdLPxx_selLine: lines,
            AIXMLReduction: reduction,
            filterShowStopList: 0,
            filterShowPlaceList: 0,
            filterShowLineList: 0,
            // date parameters
            tdLPxx_dateInterval: true,
            itdLPxx_dateDay: params.date.getDate(),
            itdLPxx_dateMonth: params.date.getMonth(),
            itdLPxx_dateYear: params.date.getFullYear(),
            filterDatePublication: dayjs(params.date).format('DD-MM-YYYY'),
            // special filters
            filterInfoType: !isUndefined(params.majorEvents) && params.majorEvents === true ? 'bannerInfo' : '',
            filterPriority: ['normal', 'high', 'veryHigh'],
            filterDateValid: !isUndefined(params.validityDate) ? dayjs(params.validityDate).format('DD-MM-YYYY') : ''
        };
        processedParams.language = params.language === LANGUAGE.EN
            ? LANGUAGE.DE
            : (params.language === LANGUAGE.LAD ? LANGUAGE.IT : params.language);
        // itdLPxx_selOperator: 'bs',
        // AIXMLReduction: ['removeCreationTime', 'removeLastModificationTime'],
        // itdLPxx_selOperator:encodeURIComponent('KVG - Stade - Hittfeld - Lüneburg'),
        // filterProviderCode:'3',
        // filterProviderCode:'1',
        // filterSourceSystemName:'bs',
        //  filterInfoType:'bannerInfo',
        // itdLPxx_dateInterval: 'true',
        // itdLPxx_dateDay: $scope.currentDay,
        // itdLPxx_dateMonth: $scope.currentMonth,
        // itdLPxx_dateYear: $scope.currentYear,
        // outputFormat: 'json',
        // filterMOTType:'5',
        // mId: efaicsconfig.mId
        return this.performRequest(endpointUrl, processedParams).pipe(mergeMap((response) => {
            // checks the HTTP Status Code
            if (response.status.code !== this.HTTPCONSTANTS.OK && response.status.code !== this.HTTPCONSTANTS.NOT_MODIFIED) {
                return throwError([{ code: 'ERROR_CODE.GENERAL_SERVER_ERROR', value: response.status.code }]);
            }
            const data = response.body;
            // checks for MENTZ Errors in Response.
            // if any code discovered complete with an error
            const errorArray = this.checkResultForServerError(data);
            if (errorArray.length > 0) {
                return throwError(errorArray);
            }
            const messages = [];
            if (!isUndefined(data.additionalInformation) && !isUndefined(data.additionalInformation.travelInformations)) {
                for (const info of data.additionalInformation.travelInformations.travelInformation) {
                    const validityPeriods = [];
                    if (!isUndefined(info.validityPeriod) && info.validityPeriod.length > 0) {
                        for (const period of info.validityPeriod) {
                            const validityStart = new Date();
                            const validityEnd = new Date();
                            validityStart.setFullYear(period.itdDateTime_From.itdDate.year);
                            validityStart.setMonth(period.itdDateTime_From.itdDate.month - 1);
                            validityStart.setDate(period.itdDateTime_From.itdDate.day);
                            validityStart.setHours(period.itdDateTime_From.itdTime.hour);
                            validityStart.setMinutes(period.itdDateTime_From.itdTime.minute);
                            validityEnd.setFullYear(period.itdDateTime_To.itdDate.year);
                            validityEnd.setMonth(period.itdDateTime_To.itdDate.month - 1);
                            validityEnd.setDate(period.itdDateTime_To.itdDate.day);
                            validityEnd.setHours(period.itdDateTime_To.itdTime.hour);
                            validityEnd.setMinutes(period.itdDateTime_To.itdTime.minute);
                            validityPeriods.push({
                                start: validityStart,
                                end: validityEnd
                            });
                        }
                    }
                    let publicationDuration;
                    if (!isUndefined(info.publicationDuration)) {
                        const publicationStart = new Date();
                        const publicationEnd = new Date();
                        publicationStart.setFullYear(info.publicationDuration.itdDateTime_From.itdDate.year);
                        publicationStart.setMonth(info.publicationDuration.itdDateTime_From.itdDate.month - 1);
                        publicationStart.setDate(info.publicationDuration.itdDateTime_From.itdDate.day);
                        publicationStart.setHours(info.publicationDuration.itdDateTime_From.itdTime.hour);
                        publicationStart.setMinutes(info.publicationDuration.itdDateTime_From.itdTime.minute);
                        publicationEnd.setFullYear(info.publicationDuration.itdDateTime_To.itdDate.year);
                        publicationEnd.setMonth(info.publicationDuration.itdDateTime_To.itdDate.month - 1);
                        publicationEnd.setDate(info.publicationDuration.itdDateTime_To.itdDate.day);
                        publicationEnd.setHours(info.publicationDuration.itdDateTime_To.itdTime.hour);
                        publicationEnd.setMinutes(info.publicationDuration.itdDateTime_To.itdTime.minute);
                        publicationDuration = {
                            start: publicationStart,
                            end: publicationEnd
                        };
                    }
                    // All lines that are affected by the traffic message
                    const affectedLines = [];
                    if (!isUndefined(info.concernedLines) && info.concernedLines.length > 0) {
                        for (const line of info.concernedLines) {
                            const mot = this.getEFA_MotMapping(Number(line.motCode), line.name);
                            affectedLines.push(Line.factory({
                                direction: TrafficNode.factory({
                                    name: line.directionName
                                }),
                                name: line.name,
                                lineNumber: line.number,
                                mot: mot,
                                lineNumberId: line.selected,
                                network: line.partialNet
                            }));
                        }
                    }
                    // All stops that are affected by the traffic message
                    const affectedStops = [];
                    if (!isUndefined(info.concernedStops) && info.concernedStops.length > 0) {
                        for (const stop of info.concernedStops) {
                            affectedStops.push(TrafficNode.factory({
                                id: stop.stopID,
                                type: TRAFFICNODE_TYPE.STOP,
                                city: stop.locality,
                                name: stop.name
                            }));
                        }
                    }
                    const language = this.getLanguageString(processedParams.language);
                    const infoLink = info.infoLink.find((e) => e.language === language.toUpperCase() || e.language === language);
                    let priority;
                    switch (info.priority) {
                        case 'veryHigh':
                            priority = DISRUPTION_PRIORITY.URGENT;
                            break;
                        case 'high':
                            priority = DISRUPTION_PRIORITY.HIGH;
                            break;
                        case 'normal':
                        default:
                            priority = DISRUPTION_PRIORITY.NORMAL;
                            break;
                    }
                    messages.push(Disruption.factory({
                        id: info.infoID,
                        headers: [
                            infoLink.subtitle,
                            infoLink.subject
                        ],
                        content: [
                            infoLink.content,
                            infoLink.additionalText
                        ],
                        url: infoLink.infoLinkURL,
                        lines: affectedLines,
                        nodes: affectedStops,
                        validityPeriod: validityPeriods,
                        publicationPeriod: publicationDuration,
                        provider: Provider.factory({
                            name: info.providerCode
                        }),
                        type: info.type === 'bannerInfo' ? DISRUPTION_TYPE.BANNER : DISRUPTION_TYPE.DISRUPTION,
                        priority: priority
                    }));
                }
            }
            return of(messages);
        }), catchError((error) => {
            if (Array.isArray(error)) {
                return throwError(error);
            }
            else {
                return throwError([{ code: 'ERROR_CODE.GENERAL_SERVER_ERROR', value: !isNullOrUndefined(error.message) ? error.message : '' }]);
            }
        }));
    }
    getLines(params) {
        const endpointUrl = 'https://www.suedtirolmobil.info/fileadmin/api/lines.json';
        const processedParams = {};
        return this.performRequest(endpointUrl, processedParams).pipe(mergeMap((response) => {
            // checks the HTTP Status Code
            if (response.status.code !== this.HTTPCONSTANTS.OK && response.status.code !== this.HTTPCONSTANTS.NOT_MODIFIED) {
                return throwError([{ code: 'ERROR_CODE.GENERAL_SERVER_ERROR', value: response.status.code }]);
            }
            const data = response.body;
            const lines = [];
            const mapMot = (motString) => {
                switch (motString) {
                    case 'Bus':
                        return MOT_TYPE.BUS;
                    case 'Zug':
                        return MOT_TYPE.TRAIN;
                    case 'Seil':
                        return MOT_TYPE.CABLEWAY;
                    default:
                        return MOT_TYPE.ANY;
                }
            };
            const getLocalizedLineName = (name) => {
                switch (params.language) {
                    case LANGUAGE.DE:
                        return name.de;
                    case LANGUAGE.IT:
                        return name.it;
                    case LANGUAGE.EN:
                        return name.en ? name.en : name.de;
                    case LANGUAGE.LAD:
                        return name.ld ? name.ld : name.it;
                    default:
                        return name.it;
                }
            };
            if (!isUndefined(data.lines)) {
                for (const line of data.lines) {
                    lines.push(Line.factory({
                        id: line.divaLineIds[0],
                        name: getLocalizedLineName(line.name),
                        lineNumber: line.lineNumber,
                        mot: Mot.factory({ type: mapMot(line.type) }),
                        metaData: {
                            divaLineIds: line.divaLineIds
                        }
                    }));
                }
            }
            return of(lines);
        }), catchError((error) => {
            if (Array.isArray(error)) {
                return throwError(error);
            }
            else {
                return throwError([{ code: 'ERROR_CODE.GENERAL_SERVER_ERROR', value: !isNullOrUndefined(error.message) ? error.message : '' }]);
            }
        }));
    }
    // private functions
    getServingMotsFromMapPin(pin) {
        const results = [];
        if (!isUndefined(pin.attrs)) {
            for (const attribute of pin.attrs) {
                if (attribute.name === 'STOP_MEANS_LIST') {
                    const splitMots = attribute.value.split(',');
                    for (const mot of splitMots) {
                        const type = this.getEFA_MotMapping(Number(mot)).type;
                        if (type !== MOT_TYPE.ANY) {
                            results.push(this.getEFA_MotMapping(Number(mot)));
                        }
                    }
                }
            }
        }
        return results;
    }
    getMatchedPlatform(platform) {
        switch (platform) {
            case 'Gleis':
                return PLATFORM_TYPE.RAILTRACK;
            default:
                return PLATFORM_TYPE.PLATFORM;
        }
    }
    /**
     * extracts connections
     *
     * 'trips' contain partialRoutes
     * 'trips.legs[].points[]' contain partialRoutes trafficNodes (arrival and departure marked by trips.legs[].points[].usage)
     * 'trips.legs[].points[].name' -> stop name
     * 'trips.legs[].points[].nameWO' -> stop name without city
     * 'trips.legs[].points[].place' -> city
     * 'trips.legs[].mode.type' -> efa mot type
     * 'trips.legs[].mode.destination' -> partialConnections.line.direction
     * 'trips.legs[].mode.name' -> partialConnections.line.name
     *
     * @param data
     * @param mmType
     * @returns {Connection[]}
     */
    assembleConnectionsFromResults(data, mmType) {
        const resultFromServer = data;
        const connections = [];
        let sessionId = '';
        let requestId = '';
        let sProduct = '';
        if (!isUndefined(resultFromServer.trips) && resultFromServer.trips !== undefined) {
            // TODO: wieso speichern der session id oder request id?
            // -> seesionId und requestId werden für frühere bzw. spätere Verbindungen benötigt!
            // Wenn im parameter Opject der JSON Antwort sessionID bzw. requestID vorkommen, dann diese im AppModel im Bezug zum
            // multi-modal-Type speichern
            if (!isUndefined(resultFromServer.parameters) && resultFromServer.parameters !== undefined) {
                for (const oParameter of resultFromServer.parameters) {
                    if (oParameter.name === 'sessionID') {
                        sessionId = oParameter.value;
                    }
                    if (oParameter.name === 'requestID') {
                        requestId = oParameter.value;
                    }
                }
            }
            // Die Routen werden im Array / Object trips des Response JSON geliefert
            resultFromServer.trips = this.getArrayEvenIfObject(resultFromServer.trips, 'trip');
            for (const route of resultFromServer.trips) {
                const partialConnections = [];
                // Die PartialRouten werden im Array / Object trips des Response JSON geliefert
                if (!isUndefined(route.legs)) {
                    route.legs = this.getArrayEvenIfObject(route.legs, 'leg');
                    for (const partialRoute of route.legs) {
                        let nodes = [];
                        const matchedMot = Mot.factory(this.getEFA_MotMapping(Number(partialRoute.mode.type), sProduct));
                        // Departure und Arrival einer Teil-Route werden in dem Array points geliefert
                        if (!isNullOrUndefined(partialRoute.points)) {
                            partialRoute.points = this.getArrayEvenIfObject(partialRoute.points, 'point');
                            const mode = partialRoute.mode;
                            let oArrivalStop;
                            let oDepartureStop;
                            const oIntermediateStops = [];
                            for (const oPoint of partialRoute.points) {
                                if (oPoint.usage === 'arrival') {
                                    oArrivalStop = this.getTimetableTrafficNodeFromStop(oPoint, this.apiToAppMatcher.matchMotToApp(matchedMot.type, matchedMot.category));
                                    oArrivalStop.platform.name = oPoint.platformName;
                                    oArrivalStop.platform.type = this.getMatchedPlatform(oPoint.pointType);
                                }
                                else if (oPoint.usage === 'departure') {
                                    oDepartureStop = this.getTimetableTrafficNodeFromStop(oPoint, this.apiToAppMatcher.matchMotToApp(matchedMot.type, matchedMot.category));
                                    oDepartureStop.platform.name = oPoint.platformName;
                                    oDepartureStop.platform.type = this.getMatchedPlatform(oPoint.pointType);
                                }
                            }
                            if (!isNullOrUndefined(partialRoute.stopSeq)) {
                                for (let i = 1; i < partialRoute.stopSeq.length - 1; i++) {
                                    // check if node has a deprture time at all. If not, the train does not stop there
                                    if (partialRoute.stopSeq[i].ref.depDateTime !== undefined) {
                                        const partialTimetableTrafficNote = this.getTimetableTrafficNodeFromStop(partialRoute.stopSeq[i], this.apiToAppMatcher.matchMotToApp(matchedMot.type, matchedMot.category));
                                        partialTimetableTrafficNote.platform.name = partialRoute.stopSeq[i].platformName;
                                        partialTimetableTrafficNote.platform.type = this.getMatchedPlatform(partialRoute.stopSeq[i].pointType);
                                        oIntermediateStops.push(partialTimetableTrafficNote);
                                    }
                                }
                            }
                            nodes.push(oDepartureStop);
                            nodes = nodes.concat(oIntermediateStops);
                            nodes.push(oArrivalStop);
                        }
                        // sProduct wird gesetzt um ICE und IC unterscheiden zu können. EFA gibt als MOT_TYPE bei allen Zügen (RB, IC, ICE etc.)
                        // immer den MOT_TYPE.TRAIN. Bei ICE und IC wird das product nicht gesetzt und ist ein leerer String, dafür wird der
                        // trainType gesetzt. Der trainType enthält, genauso wie product den Typ des Fahrzeugs, daher kann trainType für diese
                        // beiden Fälle in sProduct gespeichert und an das MotMapping weitergegeben werden um darüber die Typen im MotMapping
                        // zu unterscheiden
                        if (partialRoute.mode.product === '' || isUndefined(partialRoute.mode.product)) {
                            sProduct = partialRoute.mode.trainType;
                        }
                        else {
                            sProduct = partialRoute.mode.product;
                        }
                        const disruptions = [];
                        if (partialRoute.infos) {
                            if (partialRoute.infos.info) {
                                const validityPeriod = new Array();
                                if (!isUndefined(partialRoute.infos.info.paramList)) {
                                    for (const param of partialRoute.infos.info.paramList) {
                                        if (param.name === 'incidentDateTime') {
                                            const dateStrings = param.value.split(' - ');
                                            const validityStart = dayjs(dateStrings[0], { format: 'DD/MM/YYYY HH:mm' }).toDate();
                                            const validityEnd = dayjs(dateStrings[1], { format: 'DD/MM/YYYY HH:mm' }).toDate();
                                            validityPeriod.push({
                                                start: validityStart,
                                                end: validityEnd
                                            });
                                        }
                                    }
                                }
                                disruptions.push({
                                    id: partialRoute.infos.info.infoID,
                                    headers: [
                                        partialRoute.infos.info.infoText.subtitle,
                                        partialRoute.infos.info.infoText.subject
                                    ],
                                    content: [
                                        partialRoute.infos.info.infoText.content,
                                        partialRoute.infos.info.infoText.additionalText
                                    ],
                                    url: partialRoute.infos.info.infoLinkURL,
                                    validityPeriod: validityPeriod
                                });
                            }
                            else if (partialRoute.infos.length > 0) {
                                for (const dis of partialRoute.infos) {
                                    const validityPeriod = new Array();
                                    if (!isUndefined(dis.paramList)) {
                                        for (const param of dis.paramList) {
                                            if (param.name === 'incidentDateTime') {
                                                const dateStrings = param.value.split(' - ');
                                                const validityStart = dayjs(dateStrings[0], { format: 'DD/MM/YYYY HH:mm' }).toDate();
                                                const validityEnd = dayjs(dateStrings[1], { format: 'DD/MM/YYYY HH:mm' }).toDate();
                                                validityPeriod.push({
                                                    start: validityStart,
                                                    end: validityEnd
                                                });
                                            }
                                        }
                                    }
                                    disruptions.push({
                                        id: dis.infoID,
                                        headers: [
                                            dis.infoText.subtitle,
                                            dis.infoText.subject
                                        ],
                                        content: [
                                            dis.infoText.content,
                                            dis.infoText.additionalText
                                        ],
                                        url: dis.infoLinkURL,
                                        validityPeriod: validityPeriod
                                    });
                                }
                            }
                        }
                        const transitions = [];
                        if (!isUndefined(partialRoute.footpath) && partialRoute.interchange === undefined) {
                            for (const transition of partialRoute.footpath) {
                                const sections = [];
                                if (!isUndefined(transition.footpathElem)) {
                                    for (const section of transition.footpathElem) {
                                        sections.push(TransitionSection.factory({
                                            type: this.getTransitionSectionType(section.type, section.level)
                                        }));
                                    }
                                }
                                transitions.push(Transition.factory({
                                    duration: transition.duration,
                                    positionInOrder: this.getTransitionSequenceMapping(transition.position),
                                    sections: sections
                                }));
                            }
                        }
                        else if (partialRoute.footpath !== undefined && partialRoute.interchange !== undefined) {
                            const sections = [];
                            const motFromInterchange = this.getEFA_MotMapping(partialRoute.interchange.type, '');
                            const interchangeAsLocations = [];
                            if (!isNullOrUndefined(partialRoute.interchange.path) && partialRoute.interchange.path !== '') {
                                // split the string of the 'path' into single locations
                                let pointsOfInterchange = [];
                                pointsOfInterchange = partialRoute.interchange.path.split(' ');
                                for (const singlePoint of pointsOfInterchange) {
                                    let coordinates = [];
                                    // check for empty string, because sometimes there is an extra space in the results...
                                    if (singlePoint !== '' && singlePoint.length > 1) {
                                        coordinates = singlePoint.split(',');
                                        interchangeAsLocations.push(Location.factory({
                                            latitude: coordinates[1],
                                            longitude: coordinates[0],
                                            projection: MAP_PROJECTION.WGS84
                                        }));
                                    }
                                }
                            }
                            sections.push(TransitionSection.factory({
                                type: this.getTransitionSectionTypeFromMot(motFromInterchange),
                                pathOnMap: interchangeAsLocations
                            }));
                            transitions.push(Transition.factory({
                                duration: partialRoute.footpath[0].duration,
                                positionInOrder: this.getTransitionSequenceMapping(partialRoute.footpath[0].position),
                                sections: sections
                            }));
                        }
                        let additionalInfo = [];
                        if (!isNullOrUndefined(partialRoute.hints)) {
                            /*
                                hints is either null,
                                an object with only one hint under the key 'hint'
                                or an array of hints
                            */
                            if (partialRoute.hints.length > 1) {
                                additionalInfo = partialRoute.hints.map((hint) => {
                                    return hint.infoText;
                                });
                            }
                            else {
                                additionalInfo = [partialRoute.hints.hint.infoText];
                            }
                        }
                        // filter the ServiceHotLine for AST
                        let serviceHotLine;
                        if (!isNullOrUndefined(additionalInfo) && additionalInfo.length > 0) {
                            for (const info of additionalInfo) {
                                // search Implementation from old GVH App
                                if (info.toLowerCase().indexOf('anmeld') !== -1 || info.toLowerCase().indexOf('telefon') !== -1) {
                                    const preformattedServiceHotLine = info.replace(/[^a-z^A-Z^0-9]/mgi, '');
                                    const matchedString = preformattedServiceHotLine.match(/[0-9]{7,}/);
                                    if (!isNullOrUndefined(matchedString)) {
                                        serviceHotLine = matchedString[0];
                                    }
                                }
                            }
                        }
                        // split the string of the 'path' into single locations
                        let pointsOfPath = [];
                        const pathAsLocations = [];
                        if (!isNullOrUndefined(partialRoute.path) && partialRoute.path !== '') {
                            pointsOfPath = partialRoute.path.split(' ');
                            for (const singlePoint of pointsOfPath) {
                                let coordinates = [];
                                // check for empty string, because sometimes there is an extra space in the results...
                                if (singlePoint !== '' && singlePoint.length > 1) {
                                    coordinates = singlePoint.split(',');
                                    pathAsLocations.push(Location.factory({
                                        latitude: coordinates[1],
                                        longitude: coordinates[0],
                                        projection: MAP_PROJECTION.WGS84
                                    }));
                                }
                            }
                        }
                        partialConnections.push(PartialConnection.factory({
                            mot: Mot.factory({
                                type: this.apiToAppMatcher.matchMotToApp(matchedMot.type, matchedMot.category),
                                category: matchedMot.category
                            }),
                            line: Line.factory({
                                direction: TrafficNode.factory({
                                    id: partialRoute.mode.destID,
                                    name: partialRoute.mode.destination
                                }),
                                name: (!isNullOrUndefined(partialRoute.mode.trainType))
                                    ? (partialRoute.mode.trainType + ' ' + partialRoute.mode.number)
                                    : (this.apiToAppMatcher.matchMotToApp(matchedMot.type, matchedMot.category) === MOT_TYPE.HAILEDSHAREDTAXI)
                                        ? partialRoute.mode.number
                                        : partialRoute.mode.name,
                                lineNumber: (!isNullOrUndefined(partialRoute.mode.trainType))
                                    ? (partialRoute.mode.trainType) : (partialRoute.mode.number),
                                mot: Mot.factory({
                                    type: this.apiToAppMatcher.matchMotToApp(matchedMot.type, matchedMot.category),
                                    category: matchedMot.category
                                }),
                                operator: partialRoute.mode.diva.operator !== undefined ? partialRoute.mode.diva.operator : ''
                            }),
                            nodes: nodes,
                            disruptions: disruptions,
                            transitions: transitions,
                            // if hints are present, filter out their texts
                            additionalInfo: additionalInfo,
                            serviceHotLine: serviceHotLine,
                            pathOnMap: pathAsLocations,
                            realTimeControlled: partialRoute.controlled
                        }));
                    }
                }
                // Sets the tariffInformation for the Connection
                let tariffInformation;
                if (!isNullOrUndefined(route.itdFare)) {
                    if (!isNullOrUndefined(route.itdFare.tariffInformations)) {
                        const zoneStringArray = [];
                        // zones can be an array or object
                        if (route.itdFare.tariffInformations.tariffInformation.zones.length > 1) {
                            route.itdFare.tariffInformations.tariffInformation.zones.forEach((localZone) => {
                                zoneStringArray.push(localZone.zoneElems.zoneElem.zone);
                            });
                        }
                        else {
                            zoneStringArray.push(route.itdFare.tariffInformations.tariffInformation.zones.zone.zoneElems.zoneElem.zone);
                        }
                        let zoneMap = '';
                        let zoneMapArray = [];
                        if (!isNullOrUndefined(zoneStringArray)) {
                            let kindex = zoneStringArray.indexOf('$1');
                            if (kindex > -1) {
                                zoneMapArray = [];
                                zoneMapArray.push(zoneStringArray[kindex]);
                            }
                            kindex = zoneStringArray.indexOf('$2');
                            if (kindex > -1) {
                                zoneMapArray = [];
                                zoneMapArray.push(zoneStringArray[kindex]);
                            }
                            kindex = zoneStringArray.indexOf('$R');
                            if (kindex > -1) {
                                zoneMapArray = [];
                                zoneMapArray.push(zoneStringArray[kindex]);
                            }
                            kindex = zoneStringArray.indexOf('$U');
                            if (kindex > -1) {
                                zoneMapArray = [];
                                zoneMapArray.push(zoneStringArray[kindex]);
                            }
                            if (!(zoneMapArray.length > 0)) {
                                zoneStringArray.forEach((localElement) => {
                                    zoneMap = this.mapZone(localElement, zoneMap, '1', 'H');
                                    zoneMap = this.mapZone(localElement, zoneMap, '2', 'H');
                                    zoneMap = this.mapZone(localElement, zoneMap, '$1', 'H');
                                    zoneMap = this.mapZone(localElement, zoneMap, '$2', 'H');
                                    zoneMap = this.mapZone(localElement, zoneMap, 'H1', 'H');
                                    zoneMap = this.mapZone(localElement, zoneMap, 'H2', 'H');
                                    zoneMap = this.mapZone(localElement, zoneMap, 'R', 'R');
                                    zoneMap = this.mapZone(localElement, zoneMap, 'U', 'U');
                                    zoneMap = this.mapZone(localElement, zoneMap, '$R', 'R');
                                    zoneMap = this.mapZone(localElement, zoneMap, '$U', 'U');
                                });
                            }
                        }
                        if (!(zoneMapArray.length > 0)) {
                            zoneMapArray = zoneMap.split('');
                            const iCountZoneElem = zoneMap.length;
                            if (route.itdFare.fares.fare.unitsAdult !== 'K' && iCountZoneElem !== parseInt(route.itdFare.fares.fare.unitsAdult)) {
                                zoneMap = zoneMap.substr(0, route.itdFare.fares.fare.unitsAdult);
                                zoneMapArray = zoneMap.split('');
                            }
                            for (let index = 0; index < zoneMapArray.length; index++) {
                                const element = zoneMapArray[index];
                                if (element === 'H') {
                                    zoneMapArray[index] = 'H1H2';
                                }
                            }
                            // Korrekturen bei 'falscher' Reihenfolge
                            const sZoneString = zoneMapArray.join('');
                            switch (sZoneString) {
                                case 'URH2':
                                    zoneMapArray = ['R', 'U', 'H1H2'];
                                    break;
                                case 'UH1H2R':
                                    zoneMapArray = ['U', 'H2H1', 'R'];
                                    break;
                                case 'UH2R':
                                    zoneMapArray = ['H1H2', 'U', 'R'];
                                    break;
                                default:
                                    break;
                            }
                        }
                        // maybe there can be multiple tariffInformations for one Connection.
                        // Never appeared in live results. Response field is null instead
                        tariffInformation = TariffInformation.factory({
                            network: route.itdFare.tariffInformations.tariffInformation.net,
                            fromZone: route.itdFare.tariffInformations.tariffInformation.fromPR,
                            toZone: route.itdFare.tariffInformations.tariffInformation.toPR,
                            zoneStrings: zoneMapArray
                        });
                    }
                }
                const PRICE_IN_CENT = 100;
                const availableTickets = [];
                if (!isNullOrUndefined(route.itdFare.fares)) {
                    if (!isNullOrUndefined(route.itdFare.fares)) {
                        let fares = [];
                        // Special case when fares has only one element 'fare'
                        // This should actually never happen because a fare has
                        // at least two elements, one for the partial connection and one for the total connection
                        if (!isNullOrUndefined(route.itdFare.fares.fare)) {
                            fares.push(route.itdFare.fares.fare);
                        }
                        else {
                            fares = route.itdFare.fares;
                        }
                        // Groups the available fare attributes into ticket groups using a Map
                        // A special case for subscription based tickets ('SUBSCRIPTION') is necessary because
                        // they can be split into 'SUEDTIROL_PASS' (name is 'FARELEVEL_?')
                        // and SUEDTIROL_PASS_FAMILY (name is 'FARELEVEL_FAMILY_?')
                        const ticketGroup = new Map();
                        fares.forEach((fare) => {
                            let key = fare.id;
                            if (fare.id === 'SUBSCRIPTION') {
                                if (fare.name.includes('FARELEVEL_FAMILY')) {
                                    key = "EUREGIO_FAMILY_PASS" /* EUREGIO_FAMILY_PASS */;
                                }
                                else {
                                    key = "SUEDTIROL_PASS" /* SUEDTIROL_PASS */;
                                }
                            }
                            else if (fare.name.includes('STANDARD')) {
                                key = 'STANDARD';
                            }
                            // The attribute 'evaluationTicket' indicates that this fare element has the total price for the ticket group
                            // The additional fare elements for partial connections are discarded
                            if (fare.attrs.some((e) => e.name === 'evaluationTicket')) {
                                const priceAsString = fare.attrs.find((e) => e.name === 'priceTotalFare').value;
                                const priceInCent = Number(priceAsString.replace(',', '')) * PRICE_IN_CENT;
                                if (!ticketGroup.has(key)) {
                                    const ticketDetails = [];
                                    ticketDetails.push(PriceLevel.factory({ id: fare.name, price: priceInCent }));
                                    ticketGroup.set(key, ticketDetails);
                                }
                                else {
                                    const ticketDetails = ticketGroup.get(key);
                                    ticketDetails.push(PriceLevel.factory({ id: fare.name, price: priceInCent }));
                                }
                            }
                        });
                        // Assemble the necessary information from the fare attributes iterating each ticket group
                        Array.from(ticketGroup.keys()).forEach((ticketId) => {
                            if (ticketId === "STANDARD" /* STANDARD */) {
                                // Assemble price information for the single ticket
                                const priceLevels = ticketGroup.get(ticketId);
                                if (priceLevels.length === 1) {
                                    availableTickets.push(Ticket.factory({
                                        id: ticketId,
                                        type: TICKET_TYPE.SINGLE,
                                        priceLevels: priceLevels
                                    }));
                                }
                            }
                            else if (ticketId === "VALUECARD" /* VALUECARD */) {
                                // Assemble price information for the value ticket
                                const priceLevels = ticketGroup.get(ticketId);
                                if (priceLevels.length === 1) {
                                    availableTickets.push(Ticket.factory({
                                        id: ticketId,
                                        type: TICKET_TYPE.SINGLE,
                                        priceLevels: priceLevels
                                    }));
                                }
                            }
                            else if (ticketId === "SUEDTIROL_PASS" /* SUEDTIROL_PASS */) {
                                // Assemble price information for the suedtirol pass
                                const priceLevels = ticketGroup.get(ticketId);
                                // Sort the array according to the price level id ascending
                                priceLevels.sort((one, two) => {
                                    return (one.id + '').localeCompare(two.id);
                                });
                                availableTickets.push(Ticket.factory({
                                    id: ticketId,
                                    type: TICKET_TYPE.SUBSCRIPTION,
                                    priceLevels: priceLevels
                                }));
                            }
                            else if (ticketId === "EUREGIO_FAMILY_PASS" /* EUREGIO_FAMILY_PASS */) {
                                // assemble price information for the suedtirol pass family
                                const priceLevels = ticketGroup.get(ticketId);
                                // Sort the array according to the price level id ascending
                                priceLevels.sort((one, two) => {
                                    return (one.id + '').localeCompare(two.id);
                                });
                                availableTickets.push(Ticket.factory({
                                    id: ticketId,
                                    type: TICKET_TYPE.SUBSCRIPTION,
                                    priceLevels: priceLevels
                                }));
                            }
                            else {
                                // No matching ticket identifier
                            }
                        });
                    }
                }
                connections.push(Connection.factory({
                    availableTickets: availableTickets,
                    partialConnections: partialConnections,
                    tariffInformation: tariffInformation,
                    sessionId: sessionId,
                    requestId: requestId,
                    metaData: {
                        mmType: mmType
                    }
                }));
            }
        }
        return connections;
    }
    /**
     * Zone Mapping-Helper
     * @param zoneElement current element from zone array
     * @param zoneMap string of mapped elements
     * @param target target element for search
     * @param map replacement for target element
     */
    mapZone(zoneElement, zoneMap, target, map) {
        if (zoneElement.indexOf(target) > -1) {
            if (zoneMap.indexOf(map) === -1) {
                zoneMap += map;
            }
        }
        return zoneMap;
    }
    /**
     * Checks all passed mobilityPreferences and maps our enums to values
     * for the efa api
     * @param oParameter Arguments that got parsed from the data from the
     * application.
     * @return an Object that contains all relevant mobility parameters.
     */
    getMobilitySettings(oParameter) {
        const returnParams = {
            ptOptionsActive: 0,
            imparedOptionsActive: 0,
            changeSpeed: 'normal',
            lineRestriction: 400,
            maxChanges: 9,
            routeType: 'leasttime'
        };
        if (!isUndefined(oParameter.mobilityPreferences)) {
            if (!isUndefined(oParameter.mobilityPreferences.mobilityImpairments)) {
                for (const option of oParameter.mobilityPreferences.mobilityImpairments) {
                    switch (option) {
                        case MOBILITY_IMPAIRMENT.NONE:
                            Object.assign(returnParams, {
                                imparedOptionsActive: 0
                            });
                            break;
                        case MOBILITY_IMPAIRMENT.UNAIDEDWHEELCHAIR:
                            Object.assign(returnParams, {
                                ptOptionsActive: 1,
                                noEscalators: 1,
                                noSolidStairs: 1,
                                wheelchair: 1,
                                lowPlatformVhcl: 1,
                                imparedOptionsActive: 1
                            });
                            break;
                        case MOBILITY_IMPAIRMENT.WALKINGIMPAIRED:
                            Object.assign(returnParams, {
                                ptOptionsActive: 1,
                                noSolidStairs: 1,
                                lowPlatformVhcl: 1,
                                imparedOptionsActive: 1
                            });
                            break;
                        case MOBILITY_IMPAIRMENT.NOSTAIRS:
                            Object.assign(returnParams, {
                                noSolidStairs: 1,
                                imparedOptionsActive: 1
                            });
                            break;
                        case MOBILITY_IMPAIRMENT.NOESCALATORS:
                            Object.assign(returnParams, {
                                noEscalators: 1,
                                imparedOptionsActive: 1
                            });
                            break;
                        case MOBILITY_IMPAIRMENT.NOELEVATORS:
                            Object.assign(returnParams, {
                                noElevators: 1,
                                imparedOptionsActive: 1
                            });
                            break;
                        case MOBILITY_IMPAIRMENT.ONLYLOWPLATFORM:
                            Object.assign(returnParams, {
                                lowPlatformVhcl: 1,
                                imparedOptionsActive: 1
                            });
                            break;
                        case MOBILITY_IMPAIRMENT.ONLYWITHLIFTINGDEVICE:
                            Object.assign(returnParams, {
                                wheelchair: 1,
                                imparedOptionsActive: 1
                            });
                            break;
                        case MOBILITY_IMPAIRMENT.BIKE_TAKEALONG:
                            Object.assign(returnParams, {
                                bikeTakeAlong: 1,
                                imparedOptionsActive: 1
                            });
                            break;
                        default:
                            Object.assign(returnParams, {
                                imparedOptionsActive: 0
                            });
                            break;
                    }
                }
            }
            // line selection settings
            switch (oParameter.mobilityPreferences.lineSelection) {
                case LINE_SELECTION.ANY:
                    Object.assign(returnParams, {
                        lineRestriction: 400,
                        ptOptionsActive: 1
                    });
                    break;
                case LINE_SELECTION.NOINTERCITYEXPRESS:
                    Object.assign(returnParams, {
                        lineRestriction: 401,
                        ptOptionsActive: 1
                    });
                    break;
                case LINE_SELECTION.LOCALTRANSPORT:
                    Object.assign(returnParams, {
                        lineRestriction: 401,
                        ptOptionsActive: 1
                    });
                    break;
                default:
                    Object.assign(returnParams, {
                        lineRestriction: 400,
                        ptOptionsActive: 1
                    });
                    break;
            }
            // line selection settings
            switch (oParameter.mobilityPreferences.walkingSpeed) {
                case WALKING_SPEED.NORMAL:
                    Object.assign(returnParams, {
                        changeSpeed: 'normal',
                        itOptionsActive: 1,
                        ptOptionsActive: 1
                    });
                    break;
                case WALKING_SPEED.SLOW:
                    Object.assign(returnParams, {
                        changeSpeed: 'slow',
                        itOptionsActive: 1,
                        ptOptionsActive: 1
                    });
                    break;
                case WALKING_SPEED.FAST:
                    Object.assign(returnParams, {
                        changeSpeed: 'fast',
                        itOptionsActive: 1,
                        ptOptionsActive: 1
                    });
                    break;
                default:
                    Object.assign(returnParams, {
                        changeSpeed: 'normal',
                        itOptionsActive: 1,
                        ptOptionsActive: 1
                    });
                    break;
            }
            // number of max changes setting
            switch (oParameter.mobilityPreferences.maxChanges) {
                case MAX_CHANGE.ANY:
                    Object.assign(returnParams, {
                        maxChanges: 9,
                        ptOptionsActive: 1
                    });
                    break;
                case MAX_CHANGE.NONE:
                    Object.assign(returnParams, {
                        maxChanges: 0,
                        ptOptionsActive: 1
                    });
                    break;
                case MAX_CHANGE.ONE:
                    Object.assign(returnParams, {
                        maxChanges: 1,
                        ptOptionsActive: 1
                    });
                    break;
                case MAX_CHANGE.TWO:
                    Object.assign(returnParams, {
                        maxChanges: 2,
                        ptOptionsActive: 1
                    });
                    break;
                case MAX_CHANGE.THREE:
                    Object.assign(returnParams, {
                        maxChanges: 3,
                        ptOptionsActive: 1
                    });
                    break;
                default:
                    Object.assign(returnParams, {
                        maxChanges: 9,
                        ptOptionsActive: 1
                    });
                    break;
            }
            switch (oParameter.mobilityPreferences.routeType) {
                case ROUTE_TYPE.LEAST_CHANGES:
                    Object.assign(returnParams, {
                        routeType: 'leastchanges'
                    });
                    break;
                case ROUTE_TYPE.LEAST_WALKING:
                    Object.assign(returnParams, {
                        routeType: 'leastwalking'
                    });
                    break;
                case ROUTE_TYPE.LEAST_TIME:
                    Object.assign(returnParams, {
                        routeType: 'leasttime'
                    });
                    break;
                default:
                    Object.assign(returnParams, {
                        routeType: 'leasttime'
                    });
                    break;
            }
        }
        return returnParams;
    }
    /**
     * matches efa-sta api mot Ids to mbk MOT_TYPES
     * @param nMotType
     * @param sProduct
     * @param sInfoText
     * @returns {Mot}
     */
    getEFA_MotMapping(nMotType, sProduct = '') {
        const mot = Mot.factory({ category: TRANSPORTATION_CATEGORY.MOT });
        switch (nMotType) {
            case EFA_STA_MOT_TYPE.BUS:
                mot.type = MOT_TYPE.BUS;
                break;
            case EFA_STA_MOT_TYPE.BUS_CITYBUS:
                mot.type = MOT_TYPE.BUS_CITYBUS;
                break;
            case EFA_STA_MOT_TYPE.TRAIN:
                mot.type = MOT_TYPE.TRAIN;
                break;
            case EFA_STA_MOT_TYPE.TRAIN_URBAN:
                mot.type = MOT_TYPE.TRAIN_URBAN;
                break;
            case EFA_STA_MOT_TYPE.ON_HOLD_1:
            case EFA_STA_MOT_TYPE.ON_HOLD_2:
                mot.category = TRANSPORTATION_CATEGORY.TRANSITION;
                mot.type = TRANSITION_TYPE.STAY_IN_VEHICLE;
                break;
            case EFA_STA_MOT_TYPE.FOOTPATH_1:
            case EFA_STA_MOT_TYPE.FOOTPATH_2:
                mot.category = TRANSPORTATION_CATEGORY.TRANSITION;
                mot.type = TRANSITION_TYPE.WALKING;
                break;
            case EFA_STA_MOT_TYPE.CABLE_CAR_1:
            case EFA_STA_MOT_TYPE.CABLE_CAR_2:
                mot.type = MOT_TYPE.CABLEWAY;
                break;
            default:
                mot.type = MOT_TYPE.ANY;
        }
        return mot;
    }
    /**
     * matches efa-nds api 'position' of footpaths in partial connections to our enum
     * @param sequenceOrder
     * @returns {TRANSITION_SEQUENCE}
     */
    getTransitionSequenceMapping(sequenceOrder) {
        switch (sequenceOrder) {
            case 'BEFORE':
                return TRANSITION_SEQUENCE.BEFORE;
            case 'AFTER':
                return TRANSITION_SEQUENCE.AFTER;
            case 'IDEST':
                return TRANSITION_SEQUENCE.MAIN;
            default:
                return TRANSITION_SEQUENCE.AFTER;
        }
    }
    getTransitionSectionType(type, level) {
        switch (type) {
            case 'STAIRS':
                if (level === 'UP') {
                    return TRANSITION_TYPE.STAIRS_UP;
                }
                else {
                    return TRANSITION_TYPE.STAIRS_DOWN;
                }
            case 'ELEVATOR':
                if (level === 'UP') {
                    return TRANSITION_TYPE.ELEVATOR_UP;
                }
                else {
                    return TRANSITION_TYPE.ELEVATOR_DOWN;
                }
            case 'ESCALATOR':
                if (level === 'UP') {
                    return TRANSITION_TYPE.ESCALATOR_UP;
                }
                else {
                    return TRANSITION_TYPE.ESCALATOR_DOWN;
                }
            case 'RAMP':
                if (level === 'UP') {
                    return TRANSITION_TYPE.RAMP_UP;
                }
                else {
                    return TRANSITION_TYPE.RAMP_DOWN;
                }
            case 'LEVEL':
            default:
                return TRANSITION_TYPE.ANY;
        }
    }
    getTransitionSectionTypeFromMot(mot) {
        if (mot.category === TRANSPORTATION_CATEGORY.TRANSITION) {
            switch (mot.type) {
                case TRANSITION_TYPE.WALKING:
                default:
                    return TRANSITION_TYPE.WALKING;
            }
        }
        else {
            return TRANSITION_TYPE.CHANGE_VEHICLES;
        }
    }
    /**
     * TODO: refactoring
     * fills api params with multi modality params
     * @param processedParams
     * @param mmType
     * @returns {any}
     */
    enrichMultiModalParameters(processedParams, mmType) {
        processedParams.calcOneDirection = 1;
        processedParams.mmType = mmType;
        switch (mmType) {
            case 'bike':
                // Für multi-modale Anfragen muss das serverseitige Makro 'multimodalMacro' auf 1 gesetzt werden, dadurch werden diverse
                // Übergabe-Parameter serverseitig ge-clustert und es muss nur noch dieser eine Parameter übergeben werden
                processedParams.multimodalMacro = 1;
                // Die möglichen Parameter-Werte für die Modale sind:
                // unknown = nicht berücksichtigen
                // main = nur als direkte Verbindung suchen
                // mainconnection = als gemischte Verindung suchen
                // Es soll die Route für Fahrrad als direkte A-B Verbindung berücksichtigt werden. Die anderen Modale sollen nicht
                // berücksichtigt werden
                processedParams.levelMmBicycle = 'mainconnection';
                processedParams.levelMmCar = 'unknown';
                processedParams.levelMmTaxi = 'unknown';
                // processedParams['levelMmQuicar-Hannover'] = 'unknown';
                processedParams.levelMmStadtflitzer = 'unknown';
                processedParams['levelMmStadtmobil-Hannover'] = 'unknown';
                // Das Modal ÖV soll mit Fahrrad als Zu- und Abgang berechnet werden. Deshalb wir der Parameter hier auf
                // 'mainconnection' gesetzt
                processedParams.levelPTMm = 'unknown';
                break;
            case 'car':
                // siehe Kommentierung bei 'bike'
                processedParams.multimodalMacro = 1;
                processedParams.levelMmBicycle = 'unknown';
                processedParams.levelMmCar = 'main';
                processedParams.levelMmTaxi = 'unknown';
                // processedParams['levelMmQuicar-Hannover'] = 'unknown';
                processedParams.levelMmStadtflitzer = 'unknown';
                processedParams['levelMmStadtmobil-Hannover'] = 'unknown';
                processedParams.levelPTMm = 'unknown';
                break;
            case 'taxi':
                // siehe Kommentierung bei 'bike'
                processedParams.multimodalMacro = 1;
                processedParams.levelMmBicycle = 'unknown';
                processedParams.levelMmCar = 'unknown';
                processedParams.levelMmTaxi = 'main';
                // processedParams['levelMmQuicar-Hannover'] = 'unknown';
                processedParams.levelMmStadtflitzer = 'unknown';
                processedParams['levelMmStadtmobil-Hannover'] = 'unknown';
                processedParams.levelPTMm = 'unknown';
                break;
            case 'carsharing':
                // siehe Kommentierung bei 'bike'
                processedParams.multimodalMacro = 1;
                processedParams.levelMmBicycle = 'unknown';
                processedParams.levelMmCar = 'unknown';
                processedParams.levelMmTaxi = 'unknown';
                // processedParams['levelMmQuicar-Hannover'] = 'main';
                processedParams.levelMmStadtflitzer = 'main';
                processedParams['levelMmStadtmobil-Hannover'] = 'main';
                processedParams.levelPTMm = 'unknown';
                break;
            case 'oev':
            default:
                // Für die ÖV Verbindungen muss das Multi-Modal Makro auf 0 gesetzt werden und auch die anderen Parameter von oben sind
                // nicht nötig
                processedParams.multimodalMacro = 0;
        }
        return processedParams;
    }
    /**
     * checks for later or earlier connection searches
     * if called with command == tripNext or tripPrev -> sessionId and requestId needed for earlier or later connection searches
     * @param oArgs
     * @returns {any}
     */
    getParameterStringForTripRequest(oArgs) {
        let oParameter = {};
        if (oArgs.command === 'tripPrev' || oArgs.command === 'tripNext') {
            if (oArgs.sessionId) {
                oParameter.sessionID = oArgs.sessionId;
                oParameter.requestID = oArgs.requestId;
            }
            else {
                oParameter.sessionID = 0;
                oParameter.requestID = 0;
            }
        }
        else {
            oParameter.sessionID = 0;
            oParameter.requestID = 0;
        }
        // Wenn Parameter command mit in den Args kommt, dann diesen auch an den EFA Server mit durchreichen
        oParameter.command = oArgs.command !== undefined ? oArgs.command : '';
        // Die realtime Informationen sollen mit zurückgeliefert werden (-> useRealtime=1 setzen)
        // Dadurch gibt es im Response-JSON dann im datetime-Object die zusätzlichen attribute 'rtDate' und 'rtTime'
        oParameter.useRealtime = this.appModel.useRealtime;
        // Das coordOutputFormat wie im AppModel vorgegeben setzten (Standard in der GVH App WGS84[DD.ddddd])
        oParameter.coordOutputFormat = this.appModel.coordOutputFormat;
        // Aktiviert den EFA Location Server zur Punktverifikation. Dadurch kann die Eingabe des gesuchten Objekts über ein einziges
        // Eingabefeld name_<usage> erfolgen.
        // DOKU: http://80.154.30.143:8080/mdv/dokumentation/http-parameter-dokumentation/eingabe/gemeinsame-komponenten/odv
        oParameter.locationServerActive = 1;
        // additional Parameter, addapted from GVH.de Trip Request
        oParameter.useHouseNumberList = true;
        oParameter.useSuburb = 1;
        oParameter.stopListSubnetwork = 'nds';
        if (!isNullOrUndefined(oArgs.mobilityPreferences.useNearStations)) {
            if (oArgs.mobilityPreferences.useNearStations) {
                oParameter.trITMOTvalue100 = this.getMinuteValue(oArgs);
                oParameter.useProxFootSearch = 'on';
                oParameter.itOptionsActive = 1;
            }
        }
        // Defines maximal amount of time needed for walking
        if (!isNullOrUndefined(oArgs.mobilityPreferences.maxDistance)) {
            oParameter.trITMOTvalue100 = oArgs.mobilityPreferences.maxDistance;
        }
        // ----------------------------------
        //  add detail Parameter
        // ----------------------------------
        Object.assign(oParameter, this.getMobilitySettings(oArgs));
        Object.assign(oParameter, this.getMots(oArgs));
        // ----------------------------------
        //  add Origin Info
        // ----------------------------------
        // check, if origin is identified
        if (oArgs.originStopItem !== undefined) {
            oParameter = this.getParameterStringPart(oParameter, oArgs.originStopItem, 'origin');
        }
        // ----------------------------------
        //  add Via Info
        // ----------------------------------
        // check, if via is identified
        if (oArgs.viaStopItem !== undefined && oArgs.viaStopItem.node !== undefined) {
            oParameter = this.getParameterStringPart(oParameter, oArgs.viaStopItem, 'via');
        }
        // ----------------------------------
        //  add Destination Info
        // ----------------------------------
        if (oArgs.destinationStopItem !== undefined) {
            oParameter = this.getParameterStringPart(oParameter, oArgs.destinationStopItem, 'destination');
        }
        // ----------------------------------
        //  add Date and Time Info
        // ----------------------------------
        oParameter = this.getParameterStringTimePart(oParameter, oArgs);
        // Das Response-Format soll JSON sein (mögliche Werte: HTML | JSON | XML)
        // DOKU: http://80.154.30.143:8080/mdv/dokumentation/http-parameter-dokumentation/eingabe/gemeinsame-komponenten/
        // request-object-anfrage/?searchterm=outputFormat
        // Weitere Übergabe-Parameter, die für die Steuerung des EFAWebService nötig sind
        return oParameter;
    }
    /**
     * This function calculates the minutes for the given maxFootpath Value
     * One assumes that 1000 Meters take 15 Minutes
     * @param oArgs Params from App
     * @returns {number} calculated minutes
     */
    getMinuteValue(oArgs) {
        let minutes = 0;
        const FIFTEEN_MINUTES = 15;
        const THOUSAND_METERS = 1000;
        if (!isUndefined(oArgs.mobilityPreferences.multiModality)) {
            for (const mot of oArgs.mobilityPreferences.multiModality) {
                if (mot.type === MULTI_MODALITY_TYPE.ONFOOT) {
                    const meterToMinFactor = FIFTEEN_MINUTES / THOUSAND_METERS;
                    minutes = Math.floor(mot.maxValue * meterToMinFactor);
                }
            }
        }
        return minutes;
    }
    /**
     * TODO: currently unused
     * TODO: refactoring
     * @param oArgs
     * @returns {any}
     */
    getParameterStringForDMRequest(oArgs) {
        let oParameter = {};
        // Wenn der command Parameter mit tripPrev oder tripNext gesetzt ist, dann nutze die übergebene sessionID und requestID
        if (oArgs.command === 'dmPrev' ||
            oArgs.command === 'dmNext') {
            if (oArgs.sessionId) {
                console.log('Using Existing SessionId: ' + oArgs.sessionId + ' for Request: ' + oArgs.mmType);
                oParameter.sessionID = oArgs.sessionId;
                oParameter.requestID = oArgs.requestId;
            }
            else {
                oParameter.sessionID = 0;
                oParameter.requestID = 0;
            }
        }
        else {
            oParameter.sessionID = 0;
            oParameter.requestID = 0;
        }
        // Wenn Parameter command mit in den Args kommt, dann diesen auch an den EFA Server mit durchreichen
        oParameter.command = oArgs.command !== undefined ? oArgs.command : '';
        // Die realtime Informationen sollen mit zurückgeliefert werden (-> useRealtime=1 setzen)
        // Dadurch gibt es im Response-JSON dann im datetime-Object die zusätzlichen attribute 'rtDate' und 'rtTime'
        oParameter.useRealtime = this.appModel.useRealtime;
        // Das coordOutputFormat wie im AppModel vorgegeben setzten (Standard in der GVH App WGS84[DD.ddddd])
        oParameter.coordOutputFormat = this.appModel.coordOutputFormat;
        // Aktiviert den EFA Location Server zur Punktverifikation. Dadurch kann die Eingabe des gesuchten Objekts über ein einziges
        // Eingabefeld name_<usage> erfolgen.
        // DOKU: http://80.154.30.143:8080/mdv/dokumentation/http-parameter-dokumentation/eingabe/gemeinsame-komponenten/odv
        oParameter.locationServerActive = 1;
        oParameter.mode = 'direct';
        oParameter.useAllStops = 1;
        oParameter.depType = 'STOPEVENTS';
        oParameter.includeCompleteStopSeq = 1;
        oParameter.calcOneDirection = 1;
        if (!isUndefined(oArgs.line)) {
            oParameter.line = oArgs.line;
        }
        else {
            oParameter.dmLineSelectionAll = 1;
        }
        if (!isUndefined(oArgs.limit)) {
            oParameter.limit = oArgs.limit;
        }
        // ----------------------------------
        //  add Date and Time Info
        // ----------------------------------
        oParameter = this.getParameterStringTimePart(oParameter, oArgs);
        // ----------------------------------
        //  add detail Parameter
        // ----------------------------------
        Object.assign(oParameter, this.getMobilitySettings(oParameter));
        Object.assign(oParameter, this.getMots(oArgs));
        Object.assign(oParameter, this.getParameterStringPart(oParameter, oArgs.stopItem, 'dm'));
        // Das Response-Format soll JSON sein (mögliche Werte: HTML | JSON | XML)
        // DOKU: http://80.154.30.143:8080/mdv/dokumentation/http-parameter-dokumentation/eingabe/gemeinsame-komponenten/
        // request-object-anfrage/?searchterm=outputFormat
        // Weitere Übergabe-Parameter, die für die Steuerung des EFAWebService nötig sind
        return oParameter;
    }
    /**
     * Checks all passed mot preferences and maps our enums to values
     * for the efa api
     * @param oParameter Arguments that got parsed from the data from the
     * application.
     * @return an Object that contains all needed mot parameters for the api
     */
    getMots(oParameter) {
        // Durch den Wert checkbox wird das Einschließen von Verkehrsmitteltypen für die Fahrtberechnung aktiviert
        // DOKU: http://80.154.30.143:8080/mdv/dokumentation/http-parameter-dokumentation/eingabe/gemeinsame-komponenten/trip-options
        const returnValues = {};
        if (!isUndefined(oParameter.mobilityPreferences) && !isUndefined(oParameter.mobilityPreferences.mots)) {
            if (oParameter.mobilityPreferences.mots.length > 0) {
                for (const mot of oParameter.mobilityPreferences.mots) {
                    switch (mot) {
                        case MOT_TYPE.TRAIN:
                            Object.assign(returnValues, {
                                includedMeans: 'checkbox',
                                inclMOT_ZUG: true
                            });
                            break;
                        case MOT_TYPE.TRAIN_URBAN:
                            Object.assign(returnValues, {
                                includedMeans: 'checkbox',
                                inclMOT_1: true
                            });
                            break;
                        case MOT_TYPE.SUBWAY:
                            Object.assign(returnValues, {
                                includedMeans: 'checkbox',
                                inclMOT_2: true
                            });
                            break;
                        case MOT_TYPE.LIGHTRAIL:
                            // If there is no subway in the appsettings, every time the light rail mot-type gets checked,
                            // the subway mot-type gets checked as well. GVHMBK-2554
                            if (!isUndefined(this.appSettings.MOT_TYPE.SUBWAY)) {
                                Object.assign(returnValues, {
                                    includedMeans: 'checkbox',
                                    inclMOT_3: true
                                });
                            }
                            else {
                                Object.assign(returnValues, {
                                    includedMeans: 'checkbox',
                                    inclMOT_3: true
                                });
                                Object.assign(returnValues, {
                                    includedMeans: 'checkbox',
                                    inclMOT_2: true
                                });
                            }
                            break;
                        case MOT_TYPE.TRAM:
                            Object.assign(returnValues, {
                                includedMeans: 'checkbox',
                                inclMOT_4: true
                            });
                            break;
                        case MOT_TYPE.BUS:
                            Object.assign(returnValues, {
                                includedMeans: 'checkbox',
                                inclMOT_BUS: true
                            });
                            break;
                        case MOT_TYPE.BUS_REGIONAL:
                            Object.assign(returnValues, {
                                includedMeans: 'checkbox',
                                inclMOT_6: true
                            });
                            break;
                        case MOT_TYPE.BUS_EXPRESS:
                            Object.assign(returnValues, {
                                includedMeans: 'checkbox',
                                inclMOT_7: true
                            });
                            break;
                        case MOT_TYPE.HAILEDSHAREDTAXI:
                            Object.assign(returnValues, {
                                includedMeans: 'checkbox',
                                inclMOT_10: true
                            });
                            break;
                        case MOT_TYPE.CABLEWAY:
                            Object.assign(returnValues, {
                                includedMeans: 'checkbox',
                                inclMOT_8: true
                            });
                            break;
                        case MOT_TYPE.OTHER:
                            Object.assign(returnValues, {
                                includedMeans: 'checkbox',
                                inclMOT_11: true
                            });
                            break;
                        case MOT_TYPE.ANY:
                        default:
                            break;
                    }
                }
            }
            else {
                Object.assign(returnValues, {
                    includedMeans: 'checkbox'
                });
            }
        }
        return returnValues;
    }
    /**
     * TODO: refactoring!
     * @param oParameter
     * @param oArgs
     * @returns {any}
     */
    getParameterStringTimePart(oParameter, oArgs) {
        const DATE_MONTH_INCREASE_BECAUSE_OF_NULL_BASE = 1;
        const CHECK_IF_LOWER_THAN_10 = 10;
        const oDate = !isNullOrUndefined(oArgs.time) ? new Date(oArgs.time) : new Date();
        oParameter.itdDate = oDate.getFullYear().toString() +
            (((oDate.getMonth() + DATE_MONTH_INCREASE_BECAUSE_OF_NULL_BASE) < CHECK_IF_LOWER_THAN_10) ? '0' : '') +
            (oDate.getMonth() + 1).toString() +
            ((oDate.getDate() < CHECK_IF_LOWER_THAN_10) ? '0' : '') + oDate.getDate().toString();
        oParameter.itdTime = this.helper.formatDateTime(oDate, 'HHmm');
        oParameter.itdTripDateTimeDepArr = oArgs.isArrivalTime ? 'arr' : 'dep';
        return oParameter;
    }
    /**
     *
     * @param oParameter
     * @param stopItem
     * @param sParameter
     * @returns {any}
     */
    getParameterStringPart(oParameter, stopItem, sParameter) {
        // Prüfen, ob der nameState 'identified' ist
        if (stopItem.nameState === this.Constants.IDENTIFIED) {
            // Wenn der type des Stops (Origion oder Destination oder, wenn gewünscht Via) // TODO: evtl. Via implementieren
            if (stopItem.node.type === TRAFFICNODE_TYPE.STOP) {
                // name_origin od. name_destination (od. name_via) auf stopId setzen (ein-eindeutig für den jeweiligen EFA Server
                oParameter['name_' + sParameter] = stopItem.node.id;
                // type_origin od. type_destination (od. type_via) auf 'stop' setzen
                oParameter['type_' + sParameter] = this.Constants.STOP;
                // Wenn der type des Stops 'poi' ist und stateless gesetzt ist
            }
            else if (stopItem.node.type === TRAFFICNODE_TYPE.POI && stopItem.stateless !== undefined) {
                // name_origin od. name_destination (od. name_via) auf stateless Wert setzen (ein-eindeutig für den jeweiligen EFA Server
                oParameter['name_' + sParameter] = stopItem.node.id;
                // type_origin od. type_destination (od. type_via) auf 'any' setzen
                oParameter['type_' + sParameter] = this.Constants.ANY;
                // Wenn der type des Stops 'coord' | 'singlehouse' | 'address' | 'street' | 'poi' ist und stateless nicht gesetzt ist
            }
            else if (this.requestWithCoords(stopItem.node.type)) {
                // Wenn useCurrentPosition auf true gesetzt ist und es im AppModel auch eine Aktuelle Position gibt
                // TODO: aktuelle Position implementieren
                // name_origin od. name_destination (od. name_via) auf Koordinate des StopItem setzen Format [X]:[Y]:[FORMAT]
                // Bsp.: 9.73191:52.37470:WGS84[DD.ddddd]
                oParameter['name_' + sParameter] = stopItem.node.location.longitude + ':'
                    + stopItem.node.location.latitude + ':' + this.appModel.coordOutputFormat;
                // type_origin od. type_destination (od. type_via) auf 'coord' setzen
                oParameter['type_' + sParameter] = this.Constants.COORD;
            }
        }
        else {
            if (stopItem.node.type === TRAFFICNODE_TYPE.COORDS
                || stopItem.node.type === TRAFFICNODE_TYPE.W3W
                || stopItem.node.type === TRAFFICNODE_TYPE.PLUSCODES) {
                // name_origin od. name_destination (od. name_via) auf Koordinate des StopItem setzen Format [X]:[Y]:[FORMAT]
                // Bsp.: 9.73191:52.37470:WGS84[DD.ddddd]
                oParameter['name_' + sParameter] = stopItem.node.location.longitude + ':'
                    + stopItem.node.location.latitude + ':' + this.appModel.coordOutputFormat;
                // type_origin od. type_destination (od. type_via) auf 'coord' setzen
                oParameter['type_' + sParameter] = this.Constants.COORD;
            }
        }
        return oParameter;
    }
    /**
     * Checks the given type against the relevant Trafficnode Types
     * @param type type of origin or destination
     * @returns {boolean} inidcates if the request should be calles with Coordinates
     */
    requestWithCoords(type) {
        return type === TRAFFICNODE_TYPE.COORDS
            || type === TRAFFICNODE_TYPE.ADDRESS
            || type === TRAFFICNODE_TYPE.POI
            || type === TRAFFICNODE_TYPE.CARSHARING
            || type === TRAFFICNODE_TYPE.CARSHARING_STADTFLITZER
            || type === TRAFFICNODE_TYPE.CARSHARING_STADTMOBIL
            || type === TRAFFICNODE_TYPE.CARSHARING_GREENWHEELS
            || type === TRAFFICNODE_TYPE.PLACE;
    }
    /**
     * TODO: refactoring!
     * Gibt immer ein Array zurück, auch wenn der Input null oder ein Objekt ist
     * @param oArray
     * @param sKey
     * @returns {any}
     */
    getArrayEvenIfObject(oArray, sKey) {
        try {
            if (!oArray.length) {
                oArray = [oArray[sKey]];
            }
        }
        catch (err) {
            oArray = [];
        }
        return oArray;
    }
    /**
     * Es wird ein TimetableTrafficNode aus dem JSON-Object point (für origin bzw. destination) erzeugt
     * @param oStopItem
     * @param mode
     * @returns {TimetableTrafficNode}
     */
    getTimetableTrafficNodeFromStop(oStopItem, motType) {
        const ar_nCoords = oStopItem.ref.coords.split(',');
        let scheduledDeparture;
        let scheduledArrival;
        let realDeparture;
        let realArrival;
        if (!isUndefined(oStopItem.dateTime)) {
            const ar_sDate = oStopItem.dateTime.date.split('.');
            const ar_rt_sDate = oStopItem.dateTime.rtDate.split('.');
            const ar_sTime = oStopItem.dateTime.time.split(':');
            const ar_rt_sTime = oStopItem.dateTime.rtTime.split(':');
            const iDatePartDay = 0;
            const iDatePartMonth = 1;
            const iDatePartYear = 2;
            const iTimePartHour = 0;
            const iTimePartMinute = 1;
            const scheduledDate = new Date(Number(ar_sDate[iDatePartYear]), Number(ar_sDate[iDatePartMonth]) - 1, Number(ar_sDate[iDatePartDay]), Number(ar_sTime[iTimePartHour]), Number(ar_sTime[iTimePartMinute]));
            const actualDate = new Date(Number(ar_rt_sDate[iDatePartYear]), Number(ar_rt_sDate[iDatePartMonth]) - 1, Number(ar_rt_sDate[iDatePartDay]), Number(ar_rt_sTime[iTimePartHour]), Number(ar_rt_sTime[iTimePartMinute]));
            if (!isNullOrUndefined(oStopItem.usage) && oStopItem.usage === 'arrival') {
                scheduledArrival = scheduledDate;
                realArrival = actualDate;
            }
            else {
                scheduledDeparture = scheduledDate;
                realDeparture = actualDate;
            }
        }
        else if (!isUndefined(oStopItem.ref.depDateTime) || !isUndefined(oStopItem.ref.arrDateTime)) {
            const LENGTH_OF_YEAR = 4;
            const LENGTH_OF_MONTH = 2;
            const LENGTH_OF_DAY = 2;
            const LENGTH_OF_TIME = 2;
            if (!isUndefined(oStopItem.ref.depDateTime)) {
                const splitDate = oStopItem.ref.depDateTime.split(' ');
                const dateString = splitDate[0];
                const timeString = splitDate[1];
                scheduledDeparture = new Date(dateString.substr(0, LENGTH_OF_YEAR), dateString.substr(LENGTH_OF_YEAR, LENGTH_OF_MONTH) - 1, dateString.substr(LENGTH_OF_YEAR + LENGTH_OF_MONTH, LENGTH_OF_DAY), timeString.substr(0, LENGTH_OF_TIME), timeString.substr(LENGTH_OF_TIME + 1, LENGTH_OF_TIME));
                realDeparture = (!isUndefined(oStopItem.ref.depDelay) && oStopItem.ref.depDelay !== '')
                    ? dayjs(scheduledDeparture).add(parseInt(oStopItem.ref.depDelay), 'minute').toDate()
                    : scheduledDeparture;
            }
            if (!isUndefined(oStopItem.ref.arrDateTime)) {
                const splitDate = oStopItem.ref.arrDateTime.split(' ');
                const dateString = splitDate[0];
                const timeString = splitDate[1];
                scheduledArrival = new Date(dateString.substr(0, LENGTH_OF_YEAR), dateString.substr(LENGTH_OF_YEAR, LENGTH_OF_MONTH) - 1, dateString.substr(LENGTH_OF_YEAR + LENGTH_OF_MONTH, LENGTH_OF_DAY), timeString.substr(0, LENGTH_OF_TIME), timeString.substr(LENGTH_OF_TIME + 1, LENGTH_OF_TIME));
                realArrival = (!isUndefined(oStopItem.ref.arrDelay) && oStopItem.ref.arrDelay !== '')
                    ? dayjs(scheduledArrival).add(parseInt(oStopItem.ref.arrDelay), 'minute').toDate()
                    : scheduledArrival;
            }
        }
        // oStopItem.name without oStopItem.place for "Bus" and "Seilbahn"
        // oStopItem.nameWO without oStopItem.place for "Zug" and everything else
        let nameWithoutCity;
        let city;
        if (motType === MOT_TYPE.BUS || motType === MOT_TYPE.CABLEWAY) {
            nameWithoutCity = oStopItem.name;
            city = '';
        }
        else {
            nameWithoutCity = oStopItem.nameWO;
            city = '';
        }
        let excludeInTrip = false;
        if (oStopItem.realtimeStatus !== undefined && oStopItem.realtimeStatus !== '') {
            excludeInTrip = oStopItem.realtimeStatus === 'DEPARTURE_CANCELLED' ||
                oStopItem.realtimeStatus === 'NO_CALL_AT_STOP' ||
                oStopItem.realtimeStatus === 'TRIP_CANCELLED' ||
                oStopItem.realtimeStatus === 'ARRIVAL_CANCELLED';
        }
        const oTimetableTrafficNode = TimetableTrafficNode.factory({
            id: oStopItem.ref.id,
            name: nameWithoutCity,
            city: city,
            excludeInTrip: excludeInTrip,
            type: !isUndefined(oStopItem.placeID) && oStopItem.placeID === '-1' ? TRAFFICNODE_TYPE.ADDRESS : TRAFFICNODE_TYPE.STOP,
            location: Location.factory({
                longitude: Number(ar_nCoords[0]),
                latitude: Number(ar_nCoords[1])
            }),
            arrivalDateTime: scheduledArrival,
            departureDateTime: scheduledDeparture,
            actualArrivalDateTime: realArrival,
            actualDepartureDateTime: realDeparture
        });
        return oTimetableTrafficNode;
    }
    getTypeOfTrafficNodeForPoint(point) {
        let returnValue;
        const type = point.anyType ? point.anyType : point.type;
        switch (type) {
            case this.Constants.STOP:
                returnValue = TRAFFICNODE_TYPE.STOP;
                break;
            case this.Constants.COORD:
                returnValue = TRAFFICNODE_TYPE.COORDS;
                break;
            case this.Constants.ADDRESS:
                returnValue = TRAFFICNODE_TYPE.ADDRESS;
                break;
            case this.Constants.STREET:
                returnValue = TRAFFICNODE_TYPE.ADDRESS;
                break;
            case this.Constants.SINGLEHOUSE:
                returnValue = TRAFFICNODE_TYPE.ADDRESS;
                break;
            case this.Constants.POI:
                returnValue = TRAFFICNODE_TYPE.POI;
                break;
            case this.Constants.STADTMOBIL:
                returnValue = TRAFFICNODE_TYPE.CARSHARING_STADTMOBIL;
                break;
            case this.Constants.STADTFLITZER:
                returnValue = TRAFFICNODE_TYPE.CARSHARING_STADTFLITZER;
                break;
            case this.Constants.GREENWHEELS:
                returnValue = TRAFFICNODE_TYPE.CARSHARING_GREENWHEELS;
                break;
            case this.Constants.PLACE:
                returnValue = TRAFFICNODE_TYPE.PLACE;
                break;
            default:
                returnValue = TRAFFICNODE_TYPE.STOP;
                break;
        }
        return returnValue;
    }
    /**
     * set what errors are defined by the app settings
     * @param params
     */
    getErrorCodesFromSettings() {
        const errorSettings = this.appSettings.ERROR_CODE !== undefined ? this.helper.getEnum(this.appSettings.ERROR_CODE) : [
            ERROR_CODE.GENERAL_SERVER_ERROR,
            ERROR_CODE.CONNECTIONS_ERROR_NO_RESULTS,
            ERROR_CODE.TIMETABLES_ERROR_NO_RESULTS,
            ERROR_CODE.TRAFFICNODE_ERROR_NO_RESULTS,
            ERROR_CODE.DATE_TIME_ERROR
        ];
        let wantedErrors = [];
        for (const err of errorSettings) {
            if (err === ERROR_CODE.CONNECTIONS_ERROR_NO_RESULTS) {
                const connectionErrors = [
                    '-4000',
                    '-4001',
                    '-4002',
                    '-4003',
                    '-4004',
                    '-4005',
                    '-4006',
                    '-4007',
                    '-4008',
                    '-4009',
                    '-5000',
                    '-5008',
                    '-5009',
                    '-100',
                    '-110',
                    '-1' // Interner Berechnungsfehler
                ];
                const nextWantedErrors = wantedErrors.concat(connectionErrors);
                wantedErrors = nextWantedErrors;
            }
            if (err === ERROR_CODE.TIMETABLES_ERROR_NO_RESULTS) {
                const timetableErrors = [
                    '-4050',
                    '-1000',
                    '-2000',
                    '-3000',
                    '-3001' // Ort hat keine Adressen
                ];
                const nextWantedErrors = wantedErrors.concat(timetableErrors);
                wantedErrors = nextWantedErrors;
            }
            if (err === ERROR_CODE.TRAFFICNODE_ERROR_NO_RESULTS) {
                const trafficNodeErrors = [
                    '-8020',
                    '-303' // Location kann nicht in Adresse aufgelöst werden
                ];
                const nextWantedErrors = wantedErrors.concat(trafficNodeErrors);
                wantedErrors = nextWantedErrors;
            }
            if (err === ERROR_CODE.DATE_TIME_ERROR) {
                const dateTimeErrors = [
                    '-10',
                    '-20',
                    '-30' // Ungültiger Wert Tag
                ];
                const nextWantedErrors = wantedErrors.concat(dateTimeErrors);
                wantedErrors = nextWantedErrors;
            }
        }
        return wantedErrors;
    }
    /**
     * Checks the Response from Server for any known Errors
     * Errors appear in the itdMessageList or in dateTime Object
     * @param data Response from Server
     * @returns {string[]} Array of Error Objects
     */
    checkResultForServerError(data) {
        var _a, _b, _c, _d, _e, _f;
        const errors = [];
        const errorSettings = this.getErrorCodesFromSettings();
        if (!isNullOrUndefined(data.itdMessageList) || !isNullOrUndefined(data.message)) {
            let messageList = !isNullOrUndefined(data.itdMessageList) ? data.itdMessageList.map((el) => el.message) : [data.message];
            messageList = [
                ...messageList,
                ...((((_a = data.origin) === null || _a === void 0 ? void 0 : _a.message) !== undefined) ? (_b = data.origin) === null || _b === void 0 ? void 0 : _b.message : [])
            ];
            messageList = [
                ...messageList,
                ...((((_c = data.via) === null || _c === void 0 ? void 0 : _c.message) !== undefined) ? (_d = data.via) === null || _d === void 0 ? void 0 : _d.message : [])
            ];
            messageList = [
                ...messageList,
                ...((((_e = data.destination) === null || _e === void 0 ? void 0 : _e.message) !== undefined) ? (_f = data.destination) === null || _f === void 0 ? void 0 : _f.message : [])
            ];
            if (messageList.length > 0) {
                for (const messageObject of messageList) {
                    let indexOfCode;
                    let indexOfError;
                    let indexOfType;
                    if (messageObject.length > 0) {
                        for (let index = 0; index < messageObject.length; index++) {
                            if (!isNullOrUndefined(messageObject[index].name) && messageObject[index].name === 'code') {
                                indexOfCode = index;
                            }
                            else if (!isNullOrUndefined(messageObject[index].name) && messageObject[index].name === 'error') {
                                indexOfError = index;
                            }
                            else if (!isNullOrUndefined(messageObject[index].name) && messageObject[index].name === 'type') {
                                indexOfType = index;
                            }
                        }
                    }
                    if (!isNullOrUndefined(indexOfError) && !isNullOrUndefined(indexOfCode)) {
                        if (!isNullOrUndefined(indexOfType) && messageObject[indexOfType].value !== 'warning'
                            || isNullOrUndefined(indexOfType)) {
                            if (errorSettings.length > 0) {
                                for (const errorCode of errorSettings) {
                                    if (messageObject[0].value === errorCode) {
                                        errors.push({ code: messageObject[indexOfCode].value, value: messageObject[indexOfError].value });
                                    }
                                }
                            }
                            else {
                                errors.push({ code: messageObject[indexOfCode].value, value: messageObject[indexOfError].value });
                            }
                        }
                    }
                }
            }
        }
        if (!isNullOrUndefined(data.dateTime)) {
            if (!isNullOrUndefined(data.dateTime.message)) {
                errors.push({ code: data.dateTime.message[0].value, value: data.dateTime.message[1].value });
            }
        }
        if (!isNullOrUndefined(data.dm)) {
            if (!isNullOrUndefined(data.dm.message)) {
                errors.push({ code: data.dm.message[0].value, value: data.dm.message[1].value });
            }
        }
        return errors;
    }
    getLanguageString(language) {
        switch (language) {
            case LANGUAGE.DE:
                return 'de';
            case LANGUAGE.EN:
                return 'en';
            case LANGUAGE.IT:
                return 'it';
            case LANGUAGE.LAD:
                return 'ld1';
            default:
                return 'it';
        }
    }
    /**
     * Performs the http request and extracts the json data from the response
     * @param input Either an object of type RequestSettings or just the url of the endpoint
     * @param data The JSON object of request parameters from the app
     * @returns {Observable<R>} Observable with JSON response payload
     */
    performRequest(url, data) {
        // hardcode json output format
        const requestPayload = Object.assign(Object.assign({}, data), { outputFormat: 'JSON', outputEncoding: 'UTF-8', language: this.getLanguageString(data.language) });
        return this.http.performHttpRequest('' + this.prefix + url, {
            method: HTTP_METHOD.GET,
            payload: requestPayload,
            responseType: RESPONSE_TYPE.JSON
        });
    }
    getEfaType(type) {
        switch (type) {
            case TRAFFICNODE_TYPE.STOP:
                return 2;
            case TRAFFICNODE_TYPE.ADDRESS:
                return 12;
            default:
                return 0;
        }
    }
}
